const messages = {
  ar: {
    translations: {
      newTicketOficial: {
        createAndSend: "إنشاء وإرسال القالب",
      },
      signup: {
        title: "إنشاء حساب",
        toasts: {
          success: "تم إنشاء المستخدم بنجاح! قم بتسجيل الدخول!!!.",
          disabled:
            "تسجيل المستخدمين معطل حالياً. يرجى المحاولة مرة أخرى لاحقاً.",
          fail: "خطأ في إنشاء المستخدم. تحقق من البيانات المدخلة.",
        },
        form: {
          name: "الاسم",
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          company: "اسم المنظمة",
          phone: "واتس اب (كود الدولة + الرقم)",
        },
        buttons: {
          submit: "تسجيل",
          login: "لديك حساب بالفعل؟ ادخل!",
        },
      },
      ticketInfo: {
        copyPhone: "نسخ الهاتف",
        quickMessages: "الردود السريعة",
        phonecopied: "تم نسخ الهاتف إلى الحافظة!",
        noPhone: "لا يوجد هاتف متاح للنسخ",
        copyError: "خطأ في نسخ الهاتف",
      },
      login: {
        title: "تسجيل الدخول",
        welcome: "مرحباً بعودتك",
        loginInstruction: "أدخل بياناتك للوصول إلى حسابك",
        form: {
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          button: "الوصول",
        },
        buttons: {
          submit: "دخول",
          register: "ليس لديك حساب؟ أنشئ حساباً!",
        },
      },
      flowBuilder: {
        title: "محرر التدفقات",
        addNodes: "إضافة عقد",
        saveFlow: "حفظ التدفق",
        startOfFlow: "بداية التدفق",
        intervalLabel: "فاصل {{sec}} ثانية",
        toast: {
          saved: "تم حفظ التدفق بنجاح",
          saveError: "خطأ في حفظ التدفق",
        },
        categories: {
          basic: "أساسي",
          content: "محتوى",
          interaction: "تفاعل",
          logic: "منطق",
          system: "نظام",
          integrations: "تكاملات",
        },
        nodes: {
          start: { name: "بداية", description: "نقطة انطلاق التدفق" },
          content: { name: "محتوى", description: "إرسال نص أو صورة أو صوت أو فيديو" },
          text: { name: "نص", description: "رسالة نصية بسيطة" },
          menu: { name: "قائمة", description: "قائمة خيارات مرقمة" },
          interactiveMenu: { name: "رسالة تفاعلية API", description: "أزرار وقوائم (Baileys)" },
          input: { name: "إدخال", description: "جمع إدخال المستخدم" },
          interval: { name: "فاصل زمني", description: "إيقاف التنفيذ مؤقتاً" },
          random: { name: "عشوائي", description: "اختيار عشوائي للمسارات" },
          conditionCompare: { name: "إذا/وإلا (If/Else)", description: "تفريع التدفق حسب شرط" },
          ticket: { name: "الطوابير", description: "إدارة طوابير الخدمة" },
          tag: { name: "الوسوم", description: "إضافة وسوم لجهة الاتصال" },
          removeTag: { name: "إزالة وسم", description: "إزالة وسوم من جهة الاتصال" },
          switchFlow: { name: "تبديل التدفق", description: "التوجيه إلى تدفق آخر" },
          attendant: { name: "موظف", description: "تحويل إلى موظف" },
          httpRequest: { name: "HTTP Request", description: "طلب HTTP خارجي" },
          variable: { name: "متغير", description: "تعريف متغيرات عامة" },
          gemini: { name: "Gemini", description: "التكامل مع Gemini" },
          openai: { name: "OpenAI", description: "التكامل مع OpenAI" },
          claude: { name: "Claude", description: "التكامل مع Claude (Anthropic)" },
        },
        aiModal: {
          addTitle: "إضافة {{provider}} إلى التدفق",
          editTitle: "تعديل {{provider}} في التدفق",
          buttons: { add: "إضافة", save: "حفظ", cancel: "إلغاء" },
          basicSettings: "الإعدادات الأساسية - {{provider}}",
          assistantName: "اسم المساعد",
          apiKey: "مفتاح API لـ {{provider}}",
          model: "نموذج {{provider}}",
          systemPrompt: "موجه النظام",
          systemPromptPlaceholder: "صف كيف يجب أن يتصرف الذكاء الاصطناعي، وما المعلومات التي يجب جمعها، وكيف يجب أن يرد...",
          sendWelcomeMessage: "إرسال تحية تلقائية عند التفعيل",
          sendWelcomeMessageHelper: "تُرسل فور تفعيل هذه العقدة (\"مرحباً! أنا [اسم المساعد]...\"). عطّلها إذا كان تدفقك يرسل تحيته الخاصة قبل الوصول إلى هنا.",
          temperature: "درجة الحرارة",
          temperatureHelper: "0 = محافظ، 2 = إبداعي",
          maxTokens: "الحد الأقصى للرموز",
          maxTokensHelper: "الحد الأقصى لطول الإجابة",
          maxMessages: "الحد الأقصى للرسائل",
          maxMessagesHelper: "سجل السياق",
          voiceSettings: "إعدادات الصوت (اختياري)",
          responseType: "نوع الاستجابة",
          textOnly: "نص فقط",
          voiceKeyAzure: "مفتاح الصوت (Azure)",
          voiceKeyPlaceholder: "مفتاح خدمة Azure Speech",
          voiceRegionAzure: "منطقة الصوت (Azure)",
          voiceRegionPlaceholder: "مثال: brazilsouth",
          flowBehavior: "سلوك التدفق",
          flowBehaviorTooltip: "حدد كيف يجب أن يتصرف {{provider}} في التدفق",
          operatingMode: "وضع التشغيل",
          permanentLabel: "دائم",
          permanentDesc1: "- إنهاء التدفق هنا",
          permanentDesc2: "يستمر المستخدم في التحدث مع الذكاء الاصطناعي حتى يطلب التحويل أو الإنهاء",
          temporaryLabel: "مؤقت",
          temporaryDesc1: "- يعود إلى التدفق بعد ذلك",
          temporaryDesc2: "ينفذ الذكاء الاصطناعي مهمة محددة ثم يعود إلى التدفق العادي",
          temporarySettingsTitle: "⏱️ إعدادات الوضع المؤقت",
          temporarySettingsSubtitle: "حدد متى يجب أن يتوقف الذكاء الاصطناعي ويعود إلى التدفق",
          maxInteractions: "الحد الأقصى للتفاعلات",
          maxInteractionsHelper: "الحد الأقصى لعدد الرسائل قبل العودة إلى التدفق (0 = غير محدود)",
          timeoutMinutes: "المهلة (بالدقائق)",
          timeoutHelper: "الوقت المحدد قبل العودة إلى التدفق (0 = بدون حد)",
          continueKeywordsTitle: "كلمات مفتاحية لمتابعة التدفق",
          continueKeywordsPlaceholder: "اكتب كلمة مفتاحية",
          addKeywordButton: "إضافة",
          continueKeywordsHelper: "عندما يرسل المستخدم إحدى هذه الكلمات، سيستمر التدفق تلقائياً",
          objective: "هدف الذكاء الاصطناعي",
          objectiveHelper: "صف ما يجب أن ينجزه الذكاء الاصطناعي (مثال: 'جمع الاسم والبريد الإلكتروني والهاتف')",
          objectivePlaceholder: "مثال: جمع بيانات العميل، تأهيل الاهتمام، تشخيص المشكلة...",
          autoComplete: "الإكمال التلقائي عند تحقيق الهدف",
          autoCompleteHelper: "سيحلل الذكاء الاصطناعي تلقائياً ما إذا كان قد أكمل الهدف وسيعود إلى التدفق",
          transferQueueId: "معرف الطابور (للتحويل)",
          transferQueueHelper: "معرف الطابور الذي يتم التحويل إليه إذا طلب المستخدم موظفاً (0 = عدم التحويل)",
          validation: {
            tooShort: "قصير جداً!",
            tooLong: "طويل جداً!",
            required: "مطلوب",
            promptRequired: "صف تدريب الذكاء الاصطناعي",
            invalidModel: "نموذج غير صالح",
            modelRequired: "حدد النموذج",
            minTokens: "الحد الأدنى 10 رموز",
            maxTokensLimit: "الحد الأقصى {{max}} رمزاً",
            tokensRequired: "حدد الحد الأقصى لعدد الرموز",
            minTemp: "الحد الأدنى 0",
            maxTemp: "الحد الأقصى 2",
            temperatureRequired: "حدد درجة الحرارة",
            apiKeyRequired: "أدخل مفتاح API",
            minMessages: "الحد الأدنى رسالة واحدة",
            maxMessagesLimit: "الحد الأقصى 100 رسالة",
            messagesRequired: "حدد الحد الأقصى لعدد الرسائل",
            voiceRequired: "حدد وضع الصوت",
            voiceKeyRequired: "مفتاح الصوت مطلوب لتوليف الصوت",
            voiceRegionRequired: "منطقة الصوت مطلوبة لتوليف الصوت",
            invalidFlowMode: "وضع تدفق غير صالح",
            flowModeRequired: "حدد وضع التدفق",
            minInteractions: "الحد الأدنى تفاعل واحد",
            maxInteractionsLimit: "الحد الأقصى 50 تفاعلاً",
            minTimeout: "الحد الأدنى دقيقة واحدة",
            maxTimeoutLimit: "الحد الأقصى 60 دقيقة",
            keywordEmpty: "لا يمكن أن تكون الكلمة المفتاحية فارغة",
            keywordsRequired: "مطلوبة كلمة مفتاحية واحدة على الأقل في الوضع المؤقت",
            objectiveRequired: "الهدف مطلوب عند تفعيل الإكمال التلقائي",
          },
        },
        nodeLabels: {
          startDescription: "تُشير هذه الكتلة إلى بداية التدفق الخاص بك!",
          message: "رسالة",
          image: "صورة",
          audio: "صوت",
          video: "فيديو",
          recordedNow: "تم التسجيل الآن",
          audioSent: "تم إرسال الصوت",
          noHtml5Support: "متصفحك لا يدعم HTML5",
          seconds: "{{sec}} ثانية",
          secondsWord: "ثانية",
          numericMenu: "قائمة مرقمة",
          tag: "وسم",
          tagNotSelected: "لم يتم تحديد وسم",
          removeTagDescription: "يزيل الوسم من جهة الاتصال",
          switchFlow: "تبديل التدفق",
          queue: "طابور",
          globalVariable: "متغير عام",
          variableNameLabel: "اسم المتغير",
          valueLabel: "القيمة",
          variableValueHelper: "يمكنك استخدام قيم ثابتة أو مراجع مثل ${متغير_آخر}",
          saved: "تم الحفظ!",
          saveVariableButton: "حفظ المتغير",
          variableSavedSuccess: "تم حفظ المتغير بنجاح!",
          ifElse: "إذا / وإلا",
          and: "و",
          or: "أو",
          true: "صحيح",
          false: "خطأ",
          field: "حقل",
          value: "قيمة",
          question: "السؤال:",
          questionNotDefined: "السؤال غير محدد",
          variableToStoreAnswer: "المتغير لتخزين الإجابة:",
          variableNotDefined: "المتغير غير محدد",
          valueTooltip: "القيمة: {{value}}",
          usingVariables: "استخدام المتغيرات: {{vars}}",
          alwaysAsk: "اسأل دائماً (حتى لو كان المتغير موجوداً)",
          buttons: "أزرار",
          bodyPlaceholder: "نص الرسالة...",
          buttonDefault: "زر {{number}}",
          selectDefault: "اختر",
          itemDefault: "عنصر {{number}}",
          operators: {
            equals: "==",
            notEquals: "≠",
            contains: "∈ يحتوي",
            notContains: "∉ لا يحتوي",
            containsAny: "∈… يحتوي على أي",
            greaterThan: ">",
            lessThan: "<",
            greaterOrEqual: "≥",
            lessOrEqual: "≤",
            startsWith: "⊰ يبدأ بـ",
            endsWith: "⊱ ينتهي بـ",
            isEmpty: "∅ فارغ",
            isNotEmpty: "¬∅ غير فارغ",
            regex: ".* regex",
          },
        },
        httpRequest: {
          title: "طلب HTTP",
          presetsTitle: "Webhooks معدة مسبقاً",
          selectPreset: "اختر إعداداً مسبقاً",
          selectPresetPlaceholder: "اختر تهيئة جاهزة...",
          systemChip: "نظام",
          usingPreset: "يُستخدم الإعداد المسبق: ",
          removeButton: "إزالة",
          url: "URL",
          urlFromPreset: "URL (من الإعداد المسبق)",
          urlHelperPreset: "يمكنك تعديل الرابط الأساسي للإعداد المسبق إذا لزم الأمر",
          method: "الطريقة",
          testRequest: "اختبار الطلب",
          apiResponse: "استجابة الـ API:",
          viewFullResponse: "عرض الاستجابة الكاملة",
          showAdvanced: "إظهار الخيارات المتقدمة",
          hideAdvanced: "إخفاء الخيارات المتقدمة",
          advancedOverridePresetWarning: "قد تتجاوز الإعدادات المتقدمة تهيئة الإعداد المسبق",
          timeoutMs: "المهلة (ms)",
          queryParams: "معاملات الاستعلام",
          key: "المفتاح",
          value: "القيمة",
          addParam: "إضافة معامل",
          headersJson: "الترويسات (JSON)",
          requestBodyJson: "نص الطلب (JSON)",
          editRequestBody: "تعديل نص الطلب",
          close: "إغلاق",
          hideMapping: "إخفاء ربط متغيرات الاستجابة",
          mapResponseVariables: "ربط متغيرات الاستجابة",
          mapResponseVariablesTitle: "ربط بيانات الاستجابة بالمتغيرات",
          path: "المسار",
          pathPlaceholder: "مثال: data.user.id",
          variableName: "اسم المتغير",
          variableNamePlaceholder: "مثال: userId",
          addVariable: "إضافة متغير",
          usefulTips: "نصائح مفيدة:",
          apiResponseAutoSaved: "يتم حفظ استجابة الـ API الكاملة تلقائياً في المتغير العام",
          variableUsageTip: "يمكنك استخدام ${اسم_المتغير} في الرابط ونص الطلب لتضمين قيم المتغيرات.",
          fullResponseTitle: "الاستجابة الكاملة للـ API",
          configSaved: "تم حفظ الإعداد!",
          requestError: "خطأ في الطلب",
        },
        modals: {
          text: {
            addTitle: "إضافة رسالة إلى التدفق",
            editTitle: "تعديل رسالة التدفق",
            add: "إضافة",
            save: "حفظ",
            messageLabel: "رسالة",
          },
          interval: {
            addTitle: "إضافة فاصل زمني إلى التدفق",
            editTitle: "تعديل الفاصل الزمني",
            add: "إضافة",
            edit: "تعديل",
            secondsLabel: "الوقت بالثواني",
            toastMissingValue: "أضف قيمة الفاصل الزمني",
            toastMaxTime: "تم بلوغ الحد الأقصى للوقت: 120 ثانية",
          },
          image: {
            addTitle: "إضافة صورة إلى التدفق",
            editTitle: "تعديل الصورة",
            add: "إضافة",
            save: "حفظ",
            captionLabel: "تعليق (اختياري)",
            uploadButton: "رفع صورة",
            toastAdded: "تمت إضافة الصورة بنجاح!",
            toastFileTooBig: "الملف كبير جداً! الحد الأقصى 2 ميجابايت",
          },
          audio: {
            addTitle: "إضافة صوت إلى التدفق",
            editTitle: "تعديل الصوت",
            add: "إضافة",
            save: "حفظ",
            captionLabel: "تعليق (اختياري)",
            uploadButton: "رفع صوت",
            sendAsRecorded: "إرسال كصوت مسجل في الوقت الفعلي",
            toastAdded: "تمت إضافة الصوت بنجاح!",
            toastFileTooBig: "الملف كبير جداً! الحد الأقصى 5 ميجابايت",
          },
          video: {
            addTitle: "إضافة فيديو إلى التدفق",
            editTitle: "تعديل الفيديو",
            add: "إضافة",
            save: "حفظ",
            captionLabel: "تعليق (اختياري)",
            uploadButton: "رفع فيديو",
            mp4OnlyWarning: "تنبيه! فيديوهات MP4 فقط!",
            toastAdded: "تمت إضافة الفيديو بنجاح!",
            toastFileTooBig: "الملف كبير جداً! الحد الأقصى 20 ميجابايت",
          },
          tag: {
            addTitle: "إضافة وسم إلى التدفق",
            editTitle: "تعديل الوسم",
            add: "إضافة",
            edit: "تعديل",
            chooseTag: "اختر وسماً",
            selectTag: "حدد وسماً",
            noTagSelected: "لم يتم تحديد وسم",
            toastMissing: "أضف وسماً",
          },
          removeTag: {
            addTitle: "إزالة وسم من التدفق",
            editTitle: "تعديل إزالة الوسم",
            add: "إضافة إزالة",
            edit: "تعديل",
            chooseTagToRemove: "اختر وسماً لإزالته من جهة الاتصال",
            description: "سيؤدي هذا الإجراء إلى إزالة الوسم المحدد من جهة الاتصال عند تنفيذ التدفق",
            selectTagToRemove: "حدد وسماً لإزالته",
            noTagSelected: "لم يتم تحديد وسم",
            toastMissing: "حدد وسماً لإزالته",
          },
          switchFlow: {
            addTitle: "إضافة تبديل تدفق",
            editTitle: "تعديل تبديل التدفق",
            add: "إضافة",
            edit: "تعديل",
            chooseFlowPlaceholder: "اختر تدفقاً",
          },
          attendant: {
            addTitle: "إضافة موظف إلى التدفق",
            editTitle: "تعديل الموظف",
            add: "إضافة",
            edit: "تعديل",
            chooseAgent: "اختر موظفاً",
            selectUser: "حدد مستخدماً",
            toastMissing: "أضف موظفاً",
          },
          ticket: {
            addTitle: "إضافة طابور إلى التدفق",
            editTitle: "تعديل الطابور",
            add: "إضافة",
            edit: "تعديل",
            chooseQueue: "اختر الطابور الذي تريد التحويل إليه",
            selectConnection: "حدد اتصالاً",
            toastMissing: "أضف طابوراً",
          },
          menu: {
            addTitle: "إضافة قائمة إلى التدفق",
            editTitle: "تعديل القائمة",
            add: "إضافة",
            save: "حفظ",
            explanationLabel: "رسالة توضيحية للقائمة",
            addOption: "إضافة خيار",
            typeOption: "اكتب {{number}}",
            optionPlaceholder: "اكتب الخيار",
          },
          randomizer: {
            addTitle: "إضافة عشوائي إلى التدفق",
            editTitle: "تعديل العشوائي",
            add: "إضافة",
            edit: "تعديل",
            toastMissingValue: "أضف قيمة الفاصل الزمني",
            toastMaxTime: "تم بلوغ الحد الأقصى للوقت: 120 ثانية",
          },
          input: {
            addTitle: "إضافة إدخال إلى التدفق",
            editTitle: "تعديل إدخال التدفق",
            add: "إضافة",
            saveChanges: "حفظ التغييرات",
            questionLabel: "السؤال",
            questionTooltip: "السؤال الذي سيُرسل إلى المستخدم. يمكنك تضمين متغيرات باستخدام ${اسم_المتغير}",
            questionInputLabel: "اكتب السؤال",
            questionPlaceholder: "مثال: مرحباً {{firstName}}، كم عمرك؟",
            flowVariablesLabel: "متغيرات التدفق (انقر للإدراج):",
            variableNameLabel: "اسم المتغير",
            variableNameTooltip: "اسم المتغير الذي سيتم تخزين الإجابة فيه. لا تستخدم مسافات أو رموزاً خاصة.",
            variableNamePlaceholder: "مثال: عمر_العميل",
            variableNameHelper: "سيتم تخزين إجابة المستخدم في هذا المتغير",
            howItWorksTitle: "كيف يعمل",
            howItWorksDescription: "سيرسل هذا العقدة السؤال إلى المستخدم وينتظر الإجابة. عندما يجيب المستخدم، سيتم تخزين القيمة في المتغير المحدد وسيستمر التدفق إلى العقدة التالية.",
          },
          flowModal: {
            validation: {
              tooShort: "قصير جداً!",
              tooLong: "طويل جداً!",
              nameRequired: "اكتب اسماً!",
            },
          },
          interactive: {
            addTitle: "رسالة تفاعلية (Baileys)",
            editTitle: "تعديل الرسالة التفاعلية",
            add: "إضافة",
            save: "حفظ",
            cancel: "إلغاء",
            bodyRequired: "نص الرسالة مطلوب!",
            addAtLeastOneOption: "أضف خياراً واحداً على الأقل!",
            imageUploadError: "خطأ في رفع الصورة",
            fileTooBig: "الملف كبير جداً! الحد الأقصى 2 ميجابايت",
            maxOptionsWarning: "الحد الأقصى {{max}} خيارات للأزرار!",
            preview: "معاينة",
            messageType: "نوع الرسالة التفاعلية",
            buttonsMax3: "أزرار (الحد الأقصى 3)",
            infoBanner: "أزرار تفاعلية عبر Baileys (nativeFlowMessage). تعمل على الاتصالات غير الرسمية. الحد الأقصى 3 أزرار.",
            contentTab: "محتوى الرسالة",
            buttonsTab: "الأزرار ({{count}}/{{max}})",
            bodyLabel: "نص الرسالة",
            footerLabel: "تذييل (اختياري)",
            headerImageLabel: "صورة الترويسة (اختياري)",
            changeImage: "تغيير الصورة",
            uploadImage: "رفع صورة",
            listButtonTextLabel: "نص زر القائمة",
            listButtonTextHelper: "النص المعروض على الزر الذي يفتح القائمة",
            optionsButtons: "أزرار",
            optionsList: "خيارات القائمة",
            addButton: "إضافة",
            addAtLeastOneOptionWarning: "⚠ أضف خياراً واحداً على الأقل.",
            buttonTextPlaceholder: "نص الزر {{number}}",
            optionPlaceholder: "خيار {{number}}",
          },
          conditionCompare: {
            operators: {
              equals: "يساوي",
              notEquals: "يختلف عن",
              contains: "يحتوي على نص",
              notContains: "لا يحتوي على",
              containsAny: "يحتوي على أي (,)",
              startsWith: "يبدأ بـ",
              endsWith: "ينتهي بـ",
              greaterThan: "أكبر من",
              lessThan: "أصغر من",
              greaterOrEqual: "أكبر من أو يساوي",
              lessOrEqual: "أصغر من أو يساوي",
              isEmpty: "فارغ",
              isNotEmpty: "غير فارغ",
              regex: "تعبير نمطي",
            },
            operatorGroups: {
              Igualdade: "المساواة",
              Texto: "نص",
              "Numérico": "رقمي",
              Estado: "حالة",
              "Avançado": "متقدم",
            },
            categories: {
              "Contato": "جهة الاتصال",
              "Ticket": "التذكرة",
              "Variável Global": "متغير عام",
              "Input Capturado": "إدخال ملتقط",
              "Menu": "قائمة",
              "HTTP / API": "HTTP / API",
              "API": "API",
            },
            staticVars: {
              contactName: "اسم جهة الاتصال",
              contactEmail: "بريد جهة الاتصال",
              contactPhone: "هاتف / رقم جهة الاتصال",
              lastMessage: "آخر رسالة مستلمة",
              ticketId: "معرف التذكرة الحالية",
              ticketStatus: "حالة التذكرة (open/pending/closed)",
              ticketQueue: "طابور التذكرة الحالي",
              apiResponse: "استجابة آخر طلب HTTP",
            },
            dynamicVarDesc: {
              globalVariableValue: 'القيمة: "{{value}}"',
              globalVariableGeneric: "متغير عام للتدفق",
              inputAnswerFrom: 'إجابة عن: "{{label}}"',
              inputAnswerGeneric: "إجابة ملتقطة من المستخدم",
              menuResponse: 'إجابة القائمة: "{{message}}"',
              menuOption: 'الخيار [{{number}}] من القائمة: "{{value}}"',
              httpMappedFrom: "مأخوذ من: {{path}}",
              httpResponseVar: "متغير استجابة HTTP",
            },
            titleEdit: "تعديل الشرط",
            titleNew: "شرط جديد",
            fieldLabel: "المتغير / الحقل",
            fieldPlaceholder: "اكتب $ لرؤية المتغيرات المتاحة",
            fieldHelper: "اكتب $ لإكمال متغيرات التدفق تلقائياً",
            insertVariableTooltip: "إدراج متغير عبر المحدد",
            conditionTypeLabel: "نوع الشرط",
            comparisonValueLabel: "قيمة المقارنة",
            commaValuesLabel: "قيم مفصولة بفواصل",
            commaPlaceholder: "نعم, ن, yes, 1",
            regexHelper: "مثال: ^[0-9]{11}$ — تعبير نمطي JavaScript",
            containsAnyHelper: "أي عنصر من القائمة يفعّل صحيح",
            valueHelper: "قيمة ثابتة أو متغير باستخدام $",
            and: "و (AND)",
            or: "أو (OR)",
            addCondition: "إضافة شرط",
            logicAllTrue: "جميع الشروط",
            logicAnyTrue: "أي شرط",
            logicPrefix: "المنطق: صحيح إذا كانت",
            logicSuffix: "مستوفاة",
            quickTipsTitle: "💡 نصائح سريعة",
            tip1: "يحتوي على أي (,): افصل العناصر بفواصل ← نعم, ن, yes, 1",
            tip2: "Regex: استخدم تعبير JS ← ^[0-9]{11}$ للتحقق من وثيقة",
            tip3: "استخدم ${متغير} في أي حقل للإشارة إلى قيم ديناميكية",
            saveError: "حدث خطأ أثناء الحفظ. حاول مرة أخرى.",
            conditionFieldRequired: 'الشرط {{number}}: حقل "المتغير / الحقل" مطلوب',
            conditionValueRequired: 'الشرط {{number}}: حقل "قيمة المقارنة" مطلوب',
            cancel: "إلغاء",
            saving: "جارٍ الحفظ...",
            saveChanges: "حفظ التغييرات",
            add: "إضافة",
            selectVariable: "اختر متغيراً",
            varsFoundInFlow: "تم العثور على {{count}} متغير في التدفق",
            addVarNodesHint: "أضف عقد متغير عام أو إدخال للحصول على متغيرات ديناميكية",
            searchVariablePlaceholder: "ابحث عن متغير...",
            noVariableFound: "لم يتم العثور على متغير",
            flowVariablesTitle: "متغيرات التدفق",
          },
          singleBlock: {
            addTitle: "إضافة محتوى إلى التدفق",
            editTitle: "تعديل المحتوى",
            add: "إضافة",
            save: "حفظ",
            toastEmptyMessage: "حقول الرسالة فارغة!",
            toastIntervalRange: "لا يمكن أن يكون الفاصل الزمني 0 أو أكبر من 120!",
            toastImageTooBig: "الملف كبير جداً! الحد الأقصى 2 ميجابايت",
            toastAudioTooBig: "الملف كبير جداً! الحد الأقصى 5 ميجابايت",
            toastVideoTooBig: "الملف كبير جداً! الحد الأقصى 20 ميجابايت",
            toastDocumentTooBig: "الملف كبير جداً! الحد الأقصى 10 ميجابايت",
            toastContentAdded: "تمت إضافة المحتوى بنجاح!",
            toastDeleteEmptyCards: "احذف البطاقات الفارغة (صورة، صوت، فيديو)",
            documentLabel: "مستند",
            uploadDocument: "رفع مستند",
            viewDocument: "عرض المستند",
            availableVariables: "المتغيرات المتاحة",
            uploadingContent: "جارٍ رفع الملفات وإنشاء المحتوى...",
            variableLabels: {
              firstName: "الاسم الأول",
              name: "الاسم",
              userName: "الموظف",
              ms: "التحية",
              protocol: "البروتوكول",
              date: "التاريخ",
              hour: "الوقت",
              ticket_id: "رقم التذكرة",
              queue: "القسم",
              connection: "الاتصال",
              phoneNumber: "الهاتف",
              email: "البريد الإلكتروني",
              kanban: "Kanban",
            },
          },
        },
      },
      flowBuilderList: {
        title: "تدفقات المحادثة ({{count}})",
        searchPlaceholder: "بحث عن تدفقات...",
        importButton: "استيراد (.zip)",
        newFlowButton: "تدفق جديد",
        emptyTitleSearch: "لم يتم العثور على تدفق",
        emptyTitleNoFlows: "لم يتم إنشاء أي تدفق بعد",
        emptyDescSearch: "جرّب استخدام كلمات بحث أخرى",
        emptyDescNoFlows: "أنشئ أول تدفق محادثة لأتمتة الخدمة",
        createFirstFlow: "إنشاء أول تدفق",
        createFlowAriaLabel: "إنشاء تدفق",
        menu: {
          export: "تصدير (.zip)",
          open: "فتح التدفق",
          edit: "تعديل التدفق",
          delete: "حذف التدفق",
        },
        deleteTitle: 'حذف التدفق "{{name}}"؟',
        deleteBody: "لا يمكن التراجع عن هذا الإجراء. سيتم فقدان جميع التكاملات المرتبطة.",
        duplicateTitle: 'تكرار التدفق "{{name}}"؟',
        duplicateBody: "سيتم إنشاء نسخة من التدفق لتعديلها.",
        toast: {
          activated: "تم تفعيله",
          deactivated: "تم إلغاء تفعيله",
          toggled: "تم {{status}} التدفق بنجاح",
          deleted: "تم حذف التدفق بنجاح",
          duplicated: "تم تكرار التدفق بنجاح",
          invalidZip: "يرجى تحديد ملف ZIP (.zip)",
          imported: "تم استيراد التدفق بنجاح",
        },
      },
      floup: {
        page: {
          title: "متابعة - قوالب التدفق",
          newTemplate: "قالب جديد",
          editTemplate: "تعديل القالب",
          steps: "{{count}} خطوات",
          active: "نشط",
          inactive: "غير نشط",
          tooltips: { edit: "تعديل", duplicate: "تكرار", delete: "حذف" },
          saveError: "خطأ أثناء حفظ المتابعة. تحقق من وحدة التحكم لمزيد من التفاصيل.",
          deleteError: "خطأ أثناء حذف المتابعة. تحقق من وحدة التحكم لمزيد من التفاصيل.",
          uploadError: "خطأ أثناء رفع الملف. تحقق من وحدة التحكم لمزيد من التفاصيل.",
          defaultName: "هذه المتابعة",
          templateTypes: {
            client: { title: "قالب للعملاء", description: "تدفق تلقائي للعملاء الحاليين", defaultMessage: "مرحباً! كيف يمكننا مساعدتك اليوم؟" },
            lead: { title: "قالب للعملاء المحتملين", description: "تدفق رعاية للعملاء المحتملين الجدد", defaultMessage: "مرحباً! أهلاً بك! لدينا عرض خاص لك." },
            custom: { title: "قالب مخصص", description: "أنشئ تدفقك الخاص بشروط محددة" },
          },
          basicInfo: "معلومات أساسية",
          templateName: "اسم القالب",
          templateTypeLabel: "نوع القالب",
          templateTypeOptions: { client: "عميل", lead: "عميل محتمل", custom: "مخصص" },
          description: "الوصف",
          triggerCondition: "شرط التفعيل",
          triggerConditionHelp: "حدد متى يجب تفعيل هذه المتابعة. بمجرد التفعيل، سيتم تنفيذ جميع الخطوات بالتتابع حتى يتم استيفاء شروط الإيقاف.",
          condition: "الشرط",
          conditionOptions: { queue: "طابور النظام", tag: "وسم النظام", firstClientInteraction: "أول تفاعل للعميل", firstAttendantInteraction: "أول تفاعل للموظف" },
          queue: "الطابور",
          selectQueue: "اختر الطابور",
          tag: "الوسم",
          selectTag: "اختر الوسم",
          conditionDescription: "وصف الشرط",
          conditionDescriptionPlaceholder: "مثال: أرسل العميل أول رسالة",
          stopControls: "عناصر تحكم إيقاف التدفق",
          stopConditions: {
            anyMessage: "1. إذا رد جهة الاتصال بأي رسالة",
            keyword: "2. إذا رد جهة الاتصال بكلمة مفتاحية",
            keywordLabel: "الكلمة المفتاحية",
            keywordPlaceholder: "مثال: توقف، إلغاء، خروج",
            ticketClosed: "3. إذا تم إغلاق التذكرة",
          },
          stepsHeading: "خطوات التدفق",
          addStep: "إضافة خطوة",
          cancel: "إلغاء",
          saveTemplate: "حفظ القالب",
          step: {
            title: "الخطوة {{order}}",
            emptyMessage: "رسالة فارغة",
            attachment: "مرفق",
            message: "الرسالة",
            charsCount: "{{count}}/500 حرف",
            value: "القيمة",
            timeUnit: "وحدة الزمن",
            timeUnits: { minutes: "دقائق", hours: "ساعات", days: "أيام", weeks: "أسابيع", months: "أشهر", years: "سنوات" },
            sendAfter: "الإرسال بعد {{value}} {{unit}}",
            attachmentLink: "مرفق/رابط",
            linkOption: "رابط",
            uploadOption: "رفع",
            pasteUrl: "الصق الرابط هنا",
            removeLink: "إزالة الرابط",
            removeMedia: "إزالة الملف",
            chooseFile: "اختر ملف",
            uploading: "جارٍ إرسال {{fileName}}...",
            videoPlayerTitle: "مشغل الفيديو",
            videoNotSupported: "متصفحك لا يدعم عنصر الفيديو.",
            removeStep: "إزالة الخطوة",
          },
          preview: {
            title: "معاينة الرسالة",
            attachment: "مرفق",
            hint: "سيظهر رمز المرفق هنا",
          },
          deleteDialog: {
            title: "تأكيد الحذف",
            body: 'هل أنت متأكد أنك تريد حذف المتابعة "{{name}}"؟ لا يمكن التراجع عن هذا الإجراء وسيتم حذف جميع الوسائط المرتبطة بشكل دائم.',
            cancel: "إلغاء",
            confirm: "حذف",
          },
        },
        selector: {
          stopSuccess: "تم إيقاف المتابعة بنجاح",
          stopButton: "إيقاف المتابعة",
          nextSteps: "الخطوات التالية:",
          active: "نشط",
          selectLabel: "اختر المتابعة",
          chooseTemplate: "اختر القالب...",
          infoTooltip: "معلومات حول المتابعة",
          stageLabel: "{{name}} - المرحلة {{current}} من {{total}}",
          nextRun: "التنفيذ التالي: {{date}}",
          activeShort: "متابعة نشطة",
          noneActive: "لا توجد متابعة نشطة",
          noneActiveHelper: "جهة الاتصال هذه ليست حالياً في أي متابعة",
          infoDialog: {
            title: "حول نظام المتابعة",
            body1: "تتيح لك <strong>المتابعة</strong> إنشاء تدفقات رسائل وتعيينها لجهة اتصال أو تذكرة للتنفيذ التلقائي.",
            body2: "اختر قالباً نشطاً للبدء. يمكنك إيقافه في أي وقت.",
            close: "فهمت",
          },
        },
        dashboard: {
          title: "لوحة متابعة حسب المرحلة",
          refresh: "تحديث",
          error: "خطأ",
          next: "التالي: {{date}}",
          recentError: "⚠️ خطأ حديث",
          stage: "المرحلة {{order}}",
          noMessage: "لا توجد رسالة",
          noContactsInStage: "لا توجد جهات اتصال في هذه المرحلة",
          selectLabel: "المتابعة",
          inactive: "(غير نشط)",
          stagesCount: "المراحل",
          contactsCount: "جهات الاتصال",
          search: "بحث",
          channel: "القناة",
          allChannels: "الكل",
          selectFloup: "اختر متابعة لعرض المراحل",
          noData: "لم يتم العثور على بيانات لهذه المتابعة",
          noStages: "لم يتم العثور على مراحل",
        },
      },
      companies: {
        title: "تسجيل الشركة",
        form: {
          name: "اسم الشركة",
          plan: "الخطة",
          token: "الرمز المميز",
          submit: "تسجيل",
          success: "تم إنشاء الشركة بنجاح!",
        },
      },
      auth: {
        toasts: {
          success: "تم تسجيل الدخول بنجاح!",
        },
        dueDate: {
          expiration: "ينتهي اشتراكك في",
          days: "أيام!",
          day: "يوم!",
          expirationToday: "ينتهي اشتراكك اليوم!",
        },
        token: "الرمز المميز",
      },
      pendingTicketOverlay: {
        title: "المحادثة مقفلة",
        subtitle: "هذه المحادثة بانتظار القبول. اقبل المحادثة لعرض رسائل العميل والرد عليها.",
        statusWaiting: "الحالة: قيد الانتظار",
        defaultContactName: "جهة الاتصال",
        accepting: "جارٍ القبول...",
        acceptConversation: "قبول المحادثة",
        warning: "🚫 لا يمكنك عرض الرسائل قبل قبول المحادثة",
      },
      dashboard: {
        filters: "المرشحات",
        filter: "تصفية ",
        hideFilters: "إخفاء الفلاتر",
        showFilters: "إظهار الفلاتر",
        satisfactionSurvey: "استبيان الرضا",
        attendances: "المحادثات",
        errorFetchingTickets: "خطأ في جلب معلومات التذاكر",
        tabs: {
          indicators: "المؤشرات",
          assessments: "NPS",
          attendants: "المشغلين",
        },
        charts: {
          perDay: {
            title: "المحادثات اليوم: ",
          },
        },
        cards: {
          inAttendance: "في المحادثة",
          waiting: "في الانتظار",
          activeAttendants: "المشغلين النشطين",
          finalized: "منتهية",
          newContacts: "جهات اتصال جديدة",
          totalReceivedMessages: "الرسائل المستلمة",
          totalSentMessages: "الرسائل المرسلة",
          averageServiceTime: "متوسط وقت المحادثة",
          averageWaitingTime: "متوسط وقت الانتظار",
          status: "الحالة (الحالية)",
          activeTickets: "المحادثات النشطة",
          passiveTickets: "المحادثات غير النشطة",
          groups: "المجموعات",
        },
        users: {
          name: "الاسم",
          numberAppointments: "عدد المحادثات",
          statusNow: "الحالية",
          totalCallsUser: "إجمالي المحادثات لكل مستخدم",
          totalAttendances: "إجمالي المحادثات",
        },
        date: {
          initialDate: "التاريخ الأولي",
          finalDate: "التاريخ النهائي",
        },
        licence: {
          available: "متاح حتى",
        },
        assessments: {
          totalCalls: "إجمالي المحادثات",
          callsWaitRating: "محادثات تنتظر التقييم",
          callsWithoutRating: "محادثات بدون تقييم",
          ratedCalls: "محادثات مقيمة",
          evaluationIndex: "مؤشر التقييم",
          score: "النتيجة",
          prosecutors: "الداعمين",
          neutral: "المحايدين",
          detractors: "المنتقدين",
        },
      },
      reports: {
        title: "تقرير الاستطلاعات المنجزة",

        operator: "المشغل",
        period: "الفترة",
        until: "حتى",
        date: "التاريخ",
        reportTitle: "التقارير",
        calls: "المحادثات",
        search: "الاستطلاعات",
        durationCalls: "مدة المحادثات",
        grupoSessions: "محادثات المجموعات",
        groupTicketsReports: {
          timezone: "Asia/Riyadh",
          msgToast: "جاري إنشاء التقرير المضغوط، يرجى الانتظار.",
          errorToast: "خطأ في إنشاء التقرير",
          back: "العودة",
          groupServiceReport: "تقرير محادثات المجموعات",
          loading: "جاري التحميل...",
          contact: "جهة الاتصال",
          dateOpen: "تاريخ الفتح",
          dateLastUpdated: "تاريخ آخر تحديث",
          agent: "من قام بالمحادثة",
          agentClosed: "من أغلق المحادثة",
          waitingAssistance: "في انتظار المحادثة",
          process: "في المحادثة",
        },
        researchReports: {
          response: "إجابة",
          active: "(نشط)",
          inactive: "(غير نشط)",
          quantity: "الكمية",
          percentage: "نسبة مئوية",
          title: "تقرير الاستطلاعات المنجزة",
          activeSearch: "بحث نشط",
          inactiveSearch: "بحث غير نشط",
        },
        ticketDurationDetail: {
          msgToast: "جاري إنشاء التقرير المضغوط، يرجى الانتظار.",
          title: "تقرير مدة المحادثة",
          startService: "بداية المحادثة",
          lastUpdated: "آخر تحديث",
          lastAgent: "آخر مشغل",
          durationFinished: "المدة بعد الانتهاء",
        },
        ticketDuration: {
          title: "تقرير مدة المحادثات",
          contact: "جهة الاتصال",
          open: "مفتوحة",
          pending: "معلقة",
          finished: "منتهية",
          durationFinished: "مدة المنتهية",
          durationAfterFinished: "المدة بعد الانتهاء",
          actions: "الإجراءات",
        },
        ticketReports: {
          msgToast: "جاري إنشاء التقرير المضغوط، يرجى الانتظار.",
          title: "تقرير المحادثات",
        },
        exportExcel: {
          title: "تقارير المحادثات",
          startDate: "التاريخ الأولي",
          endDate: "التاريخ النهائي",
          notInformed: "غير محدد",
          columns: {
            id: "المعرف",
            connection: "الاتصال",
            contact: "جهة الاتصال",
            user: "المستخدم",
            queue: "الطابور",
            status: "الحالة",
            lastMessage: "آخر رسالة",
            openDate: "تاريخ الفتح",
            openTime: "وقت الفتح",
            closeDate: "تاريخ الإغلاق",
            closeTime: "وقت الإغلاق",
            supportTime: "وقت المحادثة",
            nps: "NPS",
          },
        },
        pdf: {
          title: "قائمة المحادثات المنجزة",
          exportTitle: "قائمة محادثات المجموعات المنجزة",
        },
      },
      todo: {
        newTask: "مهمة جديدة",
        add: "إضافة",
        task: "المهام",
      },
      contactImportWpModal: {
        title: "تصدير جهات الاتصال إلى إكسل",
        buttons: {
          downloadModel: "تحميل نموذج إكسل للاستيراد",
          closed: "إغلاق",
          import: "اختر ملف إكسل لاستيراد جهات الاتصال",
        },
      },
      connections: {
        title: "الاتصالات",
        waitConnection: "انتظر... سيتم إعادة تشغيل اتصالاتك!",
        newConnection: "اتصال جديد",
        restartConnections: "إعادة تشغيل الاتصالات",
        callSupport: "الاتصال بالدعم",
        newConnection: "اتصال جديد",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " اربط قنوات الخدمة الخاصة بك لاستقبال الرسائل وبدء المحادثات مع عملائك.",
        client: "العميل",
        connectedConnections: " الاتصالات المتصلة ",
        disconnectedConnections: "الاتصالات المنقطعة ",
        totalConnections: " إجمالي الاتصالات",
        total: "الإجمالي",
        connections: "اتصالات:",

        toasts: {
          deleted: "تم حذف الاتصال بنجاح!",
          closedimported: "نحن نغلق المحادثات المستوردة، يرجى الانتظار قليلاً",
        },
        confirmationModal: {
          closedImportedTitle: "إغلاق المحادثات المستوردة",
          closedImportedMessage: "إذا أكدت سيتم إغلاق جميع المحادثات المستوردة",
          deleteTitle: "حذف",
          deleteMessage: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء.",
          disconnectTitle: "قطع الاتصال",
          disconnectMessage: "هل أنت متأكد؟ ستحتاج إلى قراءة رمز QR مرة أخرى.",
        },
        buttons: {
          add: "إضافة اتصال",
          disconnect: "قطع الاتصال",
          tryAgain: "حاول مرة أخرى",
          qrcode: "رمز QR",
          newQr: "رمز QR جديد",
          closedImported: "إغلاق جميع المحادثات المستوردة",
          preparing: "تجهيز الرسائل للاستيراد",
          importing: "استيراد رسائل الواتس اب",
          newQr: "رمز QR جديد",
          processed: "تمت المعالجة",
          in: "من",
          connecting: "جاري الاتصال",
        },
        typography: {
          processed: "تمت المعالجة",
          in: "من",
          date: "تاريخ الرسالة",
        },
        toolTips: {
          disconnected: {
            title: "فشل في بدء جلسة الواتس اب",
            content:
              "تأكد من أن هاتفك متصل بالإنترنت وحاول مرة أخرى، أو اطلب رمز QR جديد",
          },
          qrcode: {
            title: "في انتظار قراءة رمز QR",
            content: "انقر على زر 'رمز QR' واقرأ رمز QR بهاتفك لبدء الجلسة",
          },
          connected: {
            title: "تم تأسيس الاتصال!",
          },
          timeout: {
            title: "فُقد الاتصال مع الهاتف",
            content:
              "تأكد من أن هاتفك متصل بالإنترنت والواتس اب مفتوح، أو انقر على زر 'قطع الاتصال' للحصول على رمز QR جديد",
          },
        },
        table: {
          name: "الاسم",
          status: "الحالة",
          lastUpdate: "آخر تحديث",
          default: "افتراضي",
          actions: "الإجراءات",
          session: "الجلسة",
          number: "رقم الواتس اب",
          color: "اللون",
          receiveComments: "استقبال التعليقات",
        },
        receiveComments: {
          enabled: "استقبال التعليقات مفعل",
          disabled: "استقبال التعليقات معطل",
          tooltip: {
            enabled: "التعليقات تُستقبل. انقر للتعطيل.",
            disabled: "التعليقات لا تُستقبل. انقر للتفعيل.",
          },
        },
      },
      showTicketOpenModal: {
        title: {
          header: "محادثة موجودة",
        },
        form: {
          message: "جهة الاتصال هذه في محادثة بالفعل:",
          user: "المشغل",
          queue: "الطابور",
          messageWait:
            "جهة الاتصال هذه تنتظر المحادثة بالفعل. اطلع على تبويب الانتظار!",
        },
        buttons: {
          close: "إغلاق",
        },
      },
      showTicketLogModal: {
        title: {
          header: "السجلات",
        },
        options: {
          create: "تم إنشاء المحادثة.",
          chatBot: "تم بدء البوت.",
          queue: " - تم تحديد الطابور.",
          open: " بدأ المحادثة.",
          access: "دخل إلى المحادثة.",
          transfered: "نقل المحادثة.",
          receivedTransfer: "استلم المحادثة المنقولة.",
          pending: "أعاد إلى الطابور.",
          closed: "أغلق المحادثة",
          reopen: "أعاد فتح المحادثة",
          redirect: "- تم التوجيه",
          clientClosed: "العميل أغلق المحادثة",
        },
      },
      whatsappModal: {
        title: {
          add: "إضافة اتصال",
          edit: "تعديل الاتصال",
        },
        tabs: {
          general: "عام",
          messages: "الرسائل",
          assessments: "NPS",
          integrations: "التكاملات",
          schedules: "ساعات العمل",
        },
        form: {
          importOldMessagesEnable: "استيراد رسائل الجهاز",
          importOldMessages: "تاريخ بداية الاستيراد",
          importRecentMessages: "تاريخ نهاية الاستيراد",
          importOldMessagesGroups: "استيراد رسائل المجموعات",
          closedTicketsPostImported: "إنهاء المحادثات بعد الاستيراد",
          name: "الاسم",
          queueRedirection: "إعادة توجيه الطابور",
          queueRedirectionDesc:
            "اختر طابوراً لجهات الاتصال التي لا تملك طابوراً ليتم توجيهها",
          default: "افتراضي",
          group: "السماح بالمجموعات",
          timeSendQueue: "الوقت بالدقائق لإعادة التوجيه للطابور",
          importAlert:
            "تنبيه: عند الحفظ، سيتم إنهاء اتصالك، وستحتاج لقراءة رمز QR مرة أخرى لاستيراد الرسائل",
          groupAsTicket: "التعامل مع المجموعات كمحادثة",
          timeCreateNewTicket: "إنشاء محادثة جديدة في x دقائق",
          maxUseBotQueues: "إرسال البوت x مرات",
          maxUseInactiveTime: "إرسال تدفق عدم النشاط x مرات",
          timeUseBotQueues: "إرسال البوت في x دقائق",
          timeToReturnQueue: "الوقت للعودة للطابور بالدقائق",
          timeAwaitActiveFlow: "الوقت لانتظار تفعيل التدفق",
          expiresTicket: "إنهاء المحادثات المفتوحة بعد x دقائق",
          expiresTicketNPS: "إنهاء المحادثات المنتظرة للتقييم بعد x دقائق",
          maxUseBotQueuesNPS: "الحد الأقصى لعدد مرات إرسال التقييم",
          closeLastMessageOptions1: "من المشغل/العميل",
          closeLastMessageOptions2: "من المشغل",
          outOfHoursMessage: "رسالة خارج ساعات العمل",
          greetingMessage: "رسالة الترحيب",
          complationMessage: "رسالة الإنهاء",
          lgpdLinkPrivacy: "رابط سياسة الخصوصية",
          lgpdMessage: "رسالة ترحيب LGPD",
          lgpdDeletedMessages: "إخفاء الرسالة المحذوفة من جهة الاتصال",
          lgpdSendMessage: "طلب تأكيد جهة الاتصال دائماً",
          ratingMessage: "رسالة التقييم - المقياس يجب أن يكون من 0 إلى 10",
          token: "رمز للتكامل الخارجي",
          sendIdQueue: "الطابور",
          inactiveMessage: "رسالة عدم النشاط",
          timeInactiveMessage: "الوقت بالدقائق لإرسال تنبيه عدم النشاط",
          flowInactiveTime: "الوقت بالدقائق لإرسال تدفق عدم النشاط",
          whenExpiresTicket: "إنهاء المحادثات المفتوحة عندما تكون آخر رسالة من",
          expiresInactiveMessage: "رسالة الإنهاء بسبب عدم النشاط",
          prompt: "الموجه",
          collectiveVacationEnd: "التاريخ النهائي",
          collectiveVacationStart: "التاريخ الأولي",
          collectiveVacationMessage: "رسالة الإجازة الجماعية",
          queueIdImportMessages: "طابور لاستيراد الرسائل",
          isOficial: "رسمي",
          phone_number_id: "معرف رقم الهاتف",
          waba_id: "معرف Waba",
          send_token: "رمز الإرسال",
          business_id: "معرف العمل",
          phone_number: "رقم الهاتف",
          triggerIntegrationOnClose: "تفعيل التكامل عند إغلاق المحادثة",
          enableIntegration: "تفعيل التكامل",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        menuItem: {
          enabled: "مفعل",
          disabled: "معطل",
          minutes: "دقائق",
        },
        success: "تم حفظ الاتصال بنجاح.",
        errorSendQueue:
          "تم تحديد وقت لإعادة توجيه الطابور، لكن لم يتم اختيار طابور للتوجيه. يجب ملء الحقلين معاً",
        errorExpiresNPS: "مطلوب تحديد وقت للتقييم عند استخدام NPS.",
        errorRatingMessage: "مطلوب تحديد رسالة تقييم عند استخدام NPS.",
      },
      qrCode: {
        message: "اقرأ رمز QR لبدء الجلسة",
      },
      contacts: {
        title: "جهات الاتصال",
        toasts: {
          deleted: "تم حذف جهة الاتصال بنجاح!",
        },
        searchPlaceholder: "البحث...",
        conversationFlows: " تدفقات المحادثة",
        addFlow: "إضافة تدفق",
        editFlow: "تعديل التدفق ",
        confirmationModal: {
          deleteTitle: "حذف ",
          importTitlte: "استيراد جهات الاتصال",
          exportContact: "تصدير جهات الاتصال",
          deleteMessage:
            "هل أنت متأكد من حذف جهة الاتصال هذه؟ جميع المحادثات المرتبطة ستفقد.",
          blockContact: "هل أنت متأكد من حظر جهة الاتصال هذه؟",
          unblockContact: "هل أنت متأكد من إلغاء حظر جهة الاتصال هذه؟",
          importMessage: "هل تريد استيراد جميع جهات الاتصال من الهاتف؟",
          importChat: "استيراد المحادثات",
          wantImport: "هل تريد استيراد جميع المحادثات من الهاتف؟",
        },
        buttons: {
          import: "استيراد جهات الاتصال",
          add: "إضافة جهة اتصال",
          export: "تصدير جهة الاتصال",
        },
        table: {
          name: "الاسم",
          whatsapp: "الاتصال",
          email: "البريد الإلكتروني",
          actions: "الإجراءات",
          lastMessage: "آخر رسالة",
          wallet: "المحفظة",
        },
        menu: {
          importYourPhone: "استيراد من الجهاز الافتراضي",
          importToExcel: "استيراد / تصدير من إكسل",
          importexport: "استيراد / تصدير",
        },
      },
      forwardMessage: {
        text: "معاد التوجيه",
      },
      forwardMessageModal: {
        title: "إعادة توجيه الرسالة",
        buttons: {
          ok: "إعادة توجيه",
        },
      },
      promptModal: {
        tabs: {
          general: "عام",
          aiModel: "الذكاء الاصطناعي والنموذج",
          messages: "الرسائل",
          voice: "الصوت",
        },
        form: {
          name: "الاسم",
          prompt: "الموجه",
          voice: "الصوت",
          max_tokens: "الحد الأقصى للرموز في الإجابة",
          temperature: "درجة الحرارة",
          apikey: "مفتاح API",
          max_messages: "الحد الأقصى للرسائل في التاريخ",
          voiceKey: "مفتاح API الصوت",
          voiceRegion: "منطقة الصوت",
          provider: "المزود",
          model: "النموذج",
          modelRecommended: "(موصى به)",
          modelEconomic: "(اقتصادي)",
          trainingLabel: "التدريب / موجه النظام",
          trainingPlaceholder: "مثال: أنت مساعد افتراضي للشركة X. دورك هو مساعدة العملاء والإجابة عن الأسئلة حول المنتجات والخدمات...",
          temperatureHelper: "0 = دقيق، 1 = إبداعي",
          maxTokensHelper: "الحد الأقصى لطول الإجابة",
          maxMessagesHelper: "سياق الذاكرة",
          greetingMessage: "رسالة الترحيب الأولية",
          greetingPlaceholder: "مثال: مرحباً {{firstName}}! 👋 أنا المساعد الافتراضي للشركة. كيف يمكنني مساعدتك؟",
          greetingHelper: "أول رسالة تُرسل للعميل عند تولي الذكاء الاصطناعي المحادثة. اتركها فارغة ليبدأ الذكاء الاصطناعي مباشرة.",
          transferMessage: "رسالة التحويل",
          transferPlaceholder: "مثال: مفهوم! سأقوم بتحويلك إلى موظف بشري. يرجى الانتظار لحظة! 😊",
          transferHelper: "رسالة تُرسل عندما يطلب العميل التحدث مع موظف.",
          errorMessage: "رسالة الخطأ",
          errorPlaceholder: "مثال: عذراً، أواجه صعوبات تقنية الآن. حاول مرة أخرى لاحقاً.",
          errorHelper: "رسالة تُرسل عند حدوث خطأ في الذكاء الاصطناعي.",
          transferKeywordsTitle: "🔑 كلمات مفتاحية للتحويل",
          transferKeywords: "كلمات مفتاحية للتحويل",
          transferKeywordsPlaceholder: "مثال: أريد التحدث مع إنسان، أريد موظف، اخرج من الذكاء الاصطناعي",
          transferKeywordsHelper: "كلمات أو عبارات مفصولة بفواصل. عندما يكتب العميل إحداها، سيتم تحويله إلى موظف. الكلمات الافتراضية للنظام تبقى فعالة.",
          voiceMode: "وضع الاستجابة",
          voiceText: "نص",
          voiceKeyAzure: "مفتاح الصوت (Azure)",
          voiceRegionAzure: "منطقة الصوت (Azure)",
          voiceOnlyOpenAiWarning: "⚠️ الاستجابة الصوتية تعمل فقط مع مزود OpenAI. مع Gemini، ستكون الاستجابة دائماً نصية.",
        },
        variables: {
          availableInPrompt: "💡 المتغيرات المتاحة في الموجه:",
          availableInMessages: "💡 المتغيرات المتاحة في الرسائل:",
          contactName: "اسم جهة الاتصال",
          firstName: "الاسم الأول",
          queueName: "اسم الطابور",
          agentName: "اسم الموظف",
          currentDate: "التاريخ الحالي",
          currentHour: "الوقت الحالي",
          greeting: "التحية (صباح الخير...)",
        },
        validation: {
          tooShort: "قصير جداً!",
          tooLong: "طويل جداً!",
          required: "مطلوب",
          promptRequired: "صف تدريب الذكاء الاصطناعي",
          voiceRequired: "حدد وضع الصوت",
          maxTokensRequired: "حدد الحد الأقصى لعدد الرموز",
          temperatureRequired: "حدد درجة الحرارة",
          apikeyRequired: "أدخل مفتاح API",
          queueRequired: "حدد الطابور",
          maxMessagesRequired: "حدد الحد الأقصى لعدد الرسائل",
          missingQueue: "حدد القسم",
        },
        success: "تم حفظ الموجه بنجاح!",
        title: {
          add: "إضافة موجه",
          edit: "تعديل الموجه",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
      },
      prompts: {
        title: "الموجهات",
        table: {
          name: "الاسم",
          queue: "القسم/الطابور",
          max_tokens: "الحد الأقصى لرموز الإجابة",
          actions: "الإجراءات",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء!",
        },
        buttons: {
          add: "إضافة موجه",
        },
        noPermission: "لا تملك هذه الشركة صلاحية الوصول إلى هذه الصفحة! سيتم إعادة توجيهك.",
      },
      contactModal: {
        title: {
          add: "إضافة جهة اتصال",
          edit: "تعديل جهة الاتصال",
        },
        form: {
          mainInfo: "بيانات جهة الاتصال",
          extraInfo: "معلومات إضافية",
          name: "الاسم",
          number: "رقم الواتس اب",
          email: "البريد الإلكتروني",
          extraName: "اسم الحقل",
          extraValue: "القيمة",
          chatBotContact: "تعطيل البوت",
          termsLGDP: "تم قبول شروط LGPD في:",
          whatsapp: "مصدر الاتصال: ",
          assignWallet: "محفظة العميل",
        },
        buttons: {
          addExtraInfo: "إضافة معلومة",
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        success: "تم حفظ جهة الاتصال بنجاح.",
        walletLinked: "تم ربط جهة الاتصال بمحفظتك بنجاح!",
        walletError: "المستخدم لا يملك طوابير مرتبطة",
        saveFirst: "يجب حفظ جهة الاتصال أولاً",
      },
      wallets: {
        title: "محافظ جهات الاتصال",
        searchPlaceholder: "البحث عن جهات الاتصال...",
        filterByUser: "تصفية حسب المستخدم",
        allUsers: "جميع المستخدمين",
        contact: "جهة الاتصال",
        user: "المستخدم",
        queue: "الطابور",
        phone: "الهاتف",
        email: "البريد الإلكتروني",
        actions: "الإجراءات",
        editWallet: "تعديل المحفظة",
        selectUser: "اختيار المستخدم",
        selectQueue: "اختيار الطابور",
        selectUserAndQueue: "اختر مستخدماً وطابوراً",
        cancel: "إلغاء",
        save: "حفظ",
        confirmDeleteTitle: "تأكيد الحذف",
        confirmDeleteMessage:
          "هل أنت متأكد من إزالة جهة الاتصال هذه من المحفظة؟",
        deleteSuccess: "تم إزالة جهة الاتصال من المحفظة بنجاح!",
        updateSuccess: "تم تحديث المحفظة بنجاح!",
        wallet: "المحفظة",
      },
      queueModal: {
        title: {
          queueData: "بيانات الطابور",
          text: "ساعات الخدمة",
          add: "إضافة طابور",
          edit: "تعديل الطابور",
          confirmationDelete: "هل أنت متأكد؟ جميع خيارات التكاملات ستحذف.",
        },
        form: {
          name: "الاسم",
          color: "اللون",
          orderQueue: "ترتيب الطابور (البوت)",
          rotate: "التناوب",
          timeRotate: "وقت التناوب",
          typeRandomMode: "نوع التناوب",
          greetingMessage: "رسالة الترحيب",
          complationMessage: "رسالة الإنهاء",
          outOfHoursMessage: "رسالة خارج ساعات العمل",
          token: "الرمز المميز",
          integrationId: "التكامل",
          fileListId: "قائمة الملفات",
          closeTicket: "إغلاق المحادثة",
          queueType: "نوع القائمة",
          message: "رسالة الإرجاع",
          queue: "طابور النقل",
          integration: "التكامل",
          file: "قائمة الملفات",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        bot: {
          title: "الخيارات",
          toolTipTitle: "أضف خيارات لبناء بوت المحادثة",
          toolTip:
            "إذا كان هناك خيار واحد فقط، سيتم اختياره تلقائياً، مما يجعل البوت يجيب برسالة الخيار ويتابع",
          selectOption: "اختر خياراً",
          text: "النص",
          attendent: "المشغل",
          queue: "الطابور",
          integration: "التكامل",
          file: "الملف",
          toolTipMessageTitle: "الرسالة مطلوبة للانتقال للمستوى التالي",
          toolTipMessageContent: "الرسالة مطلوبة للانتقال للمستوى التالي",
          selectUser: "اختر مستخدماً",
          selectQueue: "اختر طابوراً",
          selectIntegration: "اختر تكاملاً",
          addOptions: "إضافة خيارات",
        },
        serviceHours: {
          dayWeek: "يوم الأسبوع",
          startTimeA: "الوقت الأولي - الدوام أ",
          endTimeA: "الوقت النهائي - الدوام أ",
          startTimeB: "الوقت الأولي - الدوام ب",
          endTimeB: "الوقت النهائي - الدوام ب",
          monday: "الاثنين",
          tuesday: "الثلاثاء",
          wednesday: "الأربعاء",
          thursday: "الخميس",
          friday: "الجمعة",
          saturday: "السبت",
          sunday: "الأحد",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "إضافة مشروع",
          edit: "تعديل المشروع",
        },
        form: {
          id: "المعرف",
          type: "النوع",
          name: "الاسم",
          projectName: "اسم المشروع",
          language: "اللغة",
          jsonContent: "محتوى Json",
          urlN8N: "الرابط",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "الوقت بالدقائق لانتهاء المحادثة",
          typebotKeywordFinish: "كلمة إنهاء المحادثة",
          typebotKeywordRestart: "كلمة إعادة تشغيل التدفق",
          typebotRestartMessage: "رسالة عند إعادة تشغيل المحادثة",
          typebotUnknownMessage: "رسالة الخيار غير الصحيح",
          typebotDelayMessage: "الفاصل الزمني (مللي ثانية) بين الرسائل",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
          test: "اختبار البوت",
        },
        messages: {
          testSuccess: "تم اختبار التكامل بنجاح!",
          addSuccess: "تم إضافة التكامل بنجاح.",
          editSuccess: "تم تعديل التكامل بنجاح.",
        },
      },
      userModal: {
        warning: "لاستيراد الرسائل يجب قراءة رمز QR مرة أخرى !!!",
        title: {
          add: "إضافة مستخدم",
          edit: "تعديل المستخدم",
          updateImage: "تحديث الصورة",
          removeImage: "حذف الصورة",
        },
        form: {
          name: "الاسم",
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          farewellMessage: "رسالة الوداع",
          profile: "الملف الشخصي",
          startWork: "بداية العمل",
          endWork: "نهاية العمل",
          whatsapp: "الاتصال الافتراضي",
          allTicketEnable: "مفعل",
          allTicketDisable: "معطل",
          allTicket: "عرض المحادثات بدون طابور",
          allowGroup: "السماح بالمجموعات",
          defaultMenuOpen: "مفتوح",
          defaultMenuClosed: "مغلق",
          defaultMenu: "القائمة الافتراضية",
          defaultTheme: "المظهر الافتراضي",
          defaultThemeDark: "داكن",
          defaultThemeLight: "فاتح",
          allHistoric: "عرض محادثات الطوابير الأخرى",
          allHistoricEnabled: "مفعل",
          allHistoricDisabled: "معطل",
          allUserChat: "عرض محادثات المستخدمين الآخرين",
          userClosePendingTicket: "السماح بإغلاق المحادثات المعلقة",
          allowSeeMessagesInPendingTickets: "السماح بعرض المحادثات المعلقة",
          showReturnQueueButton: "إظهار زر الإرجاع للطابور",
          showTransferTicketButton: "إظهار زر نقل المحادثة",
          showDashboard: "عرض لوحة التحكم",
          allowRealTime: "عرض لوحة المحادثات",
          allowConnections: "السماح بإجراءات الاتصالات",
          showContacts: "عرض جهات الاتصال",
          showCampaign: "عرض الحملات",
          showFlow: "عرض التدفقات",
        },
        tabs: {
          general: "عام",
          permissions: "الصلاحيات",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
          addImage: "إضافة صورة",
          editImage: "تعديل الصورة",
        },
        success: "تم حفظ المستخدم بنجاح.",
      },
      companyModal: {
        title: {
          add: "إضافة شركة",
          edit: "تعديل الشركة",
        },
        form: {
          name: "الاسم",
          email: "البريد الإلكتروني",
          passwordDefault: "كلمة المرور",
          numberAttendants: "المستخدمون",
          numberConections: "الاتصالات",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        success: "تم حفظ الشركة بنجاح.",
      },
      scheduleModal: {
        title: {
          add: "جدولة جديدة",
          edit: "تعديل الجدولة",
          message: "الرسالة",
        },
        form: {
          body: "الرسالة",
          contact: "جهة الاتصال",
          sendAt: "تاريخ الجدولة",
          sentAt: "تاريخ الإرسال",
          assinar: "إرسال التوقيع",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
          addSchedule: "إضافة جدولة",
        },
        success: "تم حفظ الجدولة بنجاح.",
      },
      tagModal: {
        title: {
          add: "علامة جديدة",
          edit: "تعديل العلامة",
          addKanban: "مسار جديد",
          editKanban: "تعديل المسار",
        },
        form: {
          name: "الاسم",
          color: "اللون",
          timeLane: "الوقت بالدقائق لإعادة التوجيه للمسار",
          nextLaneId: "المسار",
          greetingMessageLane: "رسالة ترحيب المسار",
          rollbackLaneId: "العودة للمسار بعد استئناف المحادثة",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        success: "تم حفظ العلامة بنجاح.",
        successKanban: "تم حفظ المسار بنجاح.",
      },
      fileModal: {
        title: {
          add: "إضافة قائمة ملفات",
          edit: "تعديل قائمة الملفات",
        },
        buttons: {
          okAdd: "حفظ",
          okEdit: "تعديل",
          cancel: "إلغاء",
          fileOptions: "إضافة ملف",
        },
        form: {
          name: "اسم قائمة الملفات",
          message: "تفاصيل القائمة",
          fileOptions: "قائمة الملفات",
          extraName: "رسالة لإرسالها مع الملف",
          extraValue: "قيمة الخيار",
        },
        success: "تم حفظ قائمة الملفات بنجاح!",
      },
      chat: {
        noTicketMessage: "اختر محادثة لبدء المراسلة.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ اسحب وأفلت الملفات في الحقل أدناه ⬇️",
          titleFileList: "قائمة الملف(ات)",
        },
      },
      chatInternal: {
        new: "إنشاء مجموعة",
        modal: {
          conversation: "المحادثة",
          title: "الاسم",
          filterUsers: "اختيار الأعضاء",
          cancel: "إغلاق",
          save: "حفظ",
        },
        modalDelete: {
          title: "حذف المحادثة",
          message: "لا يمكن التراجع عن هذا الإجراء، تأكيد؟",
        },
      },
      ticketsManager: {
        questionCloseTicket: "هل تريد إغلاق جميع المحادثات؟",
        yes: "نعم",
        not: "لا",
        buttons: {
          newTicket: "جديدة",
          resolveAll: "حل الكل",
          close: "إغلاق",
          new: "جديدة",
        },
      },
      ticketsQueueSelect: {
        placeholder: "الطوابير",
      },
      tickets: {
        messageHidden: "رسالة مخفية",
        inbox: {
          closedAllTickets: "إغلاق جميع المحادثات؟",
          closedAll: "إغلاق الكل",
          newTicket: "محادثة جديدة",
          yes: "نعم",
          no: "لا",
          open: "مفتوحة",
          resolverd: "محلولة",
        },
        toasts: {
          deleted: "المحادثة التي كنت فيها تم حذفها.",
        },
        notification: {
          message: "رسالة من",
          messageHidden: "رسالة مخفية",
        },
        tabs: {
          open: { title: "مفتوحة" },
          closed: { title: "محلولة" },
          search: { title: "البحث" },
        },
        search: {
          placeholder: "البحث في المحادثات والرسائل",
          filterConections: "تصفية حسب الاتصال",
          filterConectionsOptions: {
            open: "مفتوح",
            closed: "مغلق",
            pending: "معلق",
          },
          filterUsers: "تصفية حسب المستخدمين",
          filterContacts: "تصفية حسب جهات الاتصال",
          ticketsPerPage: "محادثات لكل صفحة",
        },
        buttons: {
          showAll: "الكل",
          returnQueue: "إرجاع للطابور",
          scredule: "جدولة",
          deleteTicket: "حذف المحادثة",
        },
        closedTicket: {
          closedMessage: "إغلاق المحادثة مع رسالة الوداع",
          closedNotMessage: "إغلاق المحادثة بدون رسالة الوداع",
        },
      },
      transferTicketModal: {
        title: "نقل المحادثة",
        fieldLabel: "اكتب للبحث عن المستخدمين",
        fieldQueueLabel: "النقل للطابور",
        fieldQueuePlaceholder: "اختر طابوراً",
        fieldWhatsapp: "اختر واتس اب",
        noOptions: "لم يتم العثور على مستخدم بهذا الاسم",
        msgTransfer: "ملاحظات - رسالة داخلية، لن تذهب للعميل",
        buttons: {
          ok: "نقل",
          cancel: "إلغاء",
        },
      },
      chatInternal: {
        new: "إنشاء مجموعة",
        modal: {
          conversation: "المحادثة",
          title: "الاسم",
          filterUsers: "اختيار الأعضاء",
          cancel: "إغلاق",
          save: "حفظ",
        },
        modalDelete: {
          title: "حذف المحادثة",
          message: "لا يمكن التراجع عن هذا الإجراء، تأكيد؟",
        },
      },
      ticketsList: {
        called: "المحادثة",
        today: "اليوم",
        missedCall: "مكالمة صوتية/فيديو فائتة في",
        pendingHeader: "في الانتظار",
        assignedHeader: "جاري المحادثة",
        groupingHeader: "المجموعات",
        noTicketsTitle: "لا شيء هنا!",
        noTicketsMessage: "لا توجد محادثة بهذه الحالة أو المصطلح المبحوث عنه",
        noQueue: "بدون طابور",
        buttons: {
          accept: "قبول",
          cancel: "إلغاء",
          start: "بدء",
          closed: "إغلاق",
          reopen: "إعادة فتح",
          transfer: "نقل",
          ignore: "تجاهل",
          exportAsPDF: "تصدير كـ PDF",
          kanbanActions: "خيارات الكانبان",
        },
        acceptModal: {
          title: "قبول المحادثة",
          queue: "اختيار القسم",
        },
      },
      newTicketModal: {
        title: "إنشاء محادثة",
        fieldLabel: "اكتب للبحث عن جهة الاتصال",
        add: "إضافة",
        selectQueue: "اختر طابوراً",
        selectConnection: "اختر اتصالاً",
        queueRequired: "اختر طابوراً",
        otherUser: "مستخدم آخر",
        buttons: {
          ok: "حفظ",
          cancel: "إلغاء",
        },
      },
      SendContactModal: {
        title: "إرسال جهة اتصال",
        fieldLabel: "اكتب للبحث عن جهة الاتصال",
        add: "إضافة",
        buttons: {
          ok: "إرسال",
          cancel: "إلغاء",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "لوحة التحكم",
          connections: "الاتصالات",
          chatsTempoReal: "اللوحة",
          tickets: "المحادثات",
          quickMessages: "الردود السريعة",
          contacts: "جهات الاتصال",
          wallets: "المحافظ",
          queues: "الطوابير والبوت",
          tags: "العلامات",
          administration: "الإدارة",
          companies: "الشركات",
          users: "المستخدمون",
          birthdaySettings: "إعدادات أعياد الميلاد",
          settings: "الإعدادات",
          files: "قائمة الملفات",
          helps: "المساعدة",
          messagesAPI: "API",
          schedules: "الجدولة",
          campaigns: "الحملات",
          annoucements: "الإعلانات",
          chats: "المحادثة الداخلية",
          financeiro: "المالية",
          queueIntegration: "التكاملات",
          version: "الإصدار",
          kanban: "الكانبان",
          prompts: "Talk.Ai",
          allConnections: "إدارة الاتصالات",
          reports: "التقارير",
          management: "الإدارة",
          callHistorical: "سجل المكالمات",
          automations: "الأتمتة",
          campaignFlow: "تدفق الحملة",
          conversationFlow: "تدفق المحادثة",
          followUpTemplates: "متابعة (القوالب)",
        },
        appBar: {
          user: {
            profile: "الملف الشخصي",
            logout: "خروج",
            message: "مرحباً",
            messageEnd: "مرحباً بك في",
            active: "نشط حتى",
            goodMorning: "مرحباً،",
            myName: "اسمي",
            continuity: "وسأتابع محادثتك.",
            virtualAssistant: "المساعد الافتراضي",
            token: "رمز غير صالح، يرجى الاتصال بمسؤول المنصة.",
          },
          message: {
            location: "الموقع",
            contact: "جهة الاتصال",
          },
          notRegister: "لا يوجد سجل",
          refresh: "تحديث",
        },
      },
      languages: {
        undefined: "اللغة",
        "pt-BR": "البرتغالية",
        es: "الإسبانية",
        en: "الإنجليزية",
        tr: "التركية",
        ar: "العربية",
      },
      messagesAPI: {
        title: "API",
        toSend: "إرسال",
        textMessage: {
          number: "الرقم",
          body: "الرسالة",
          token: "الرمز المسجل",
          userId: "معرف المستخدم/المشغل",
          queueId: "معرف الطابور",
        },
        mediaMessage: {
          number: "الرقم",
          body: "اسم الملف",
          media: "الملف",
          token: "الرمز المسجل",
        },
        API: {
          title: "وثائق إرسال الرسائل",
          methods: {
            title: "طرق الإرسال",
            messagesText: "الرسائل النصية",
            messagesMidia: "الرسائل الوسائطية",
          },
          instructions: {
            title: "التعليمات",
            comments: "ملاحظات مهمة",
            comments1:
              "قبل إرسال الرسائل، يجب تسجيل الرمز المرتبط بالاتصال الذي سيرسل الرسائل. <br />للتسجيل، ادخل إلى قائمة 'الاتصالات'، انقر على زر تعديل الاتصال وأدخل الرمز في الحقل المخصص.",
            comments2:
              "رقم الإرسال يجب ألا يحتوي على قناع أو رموز خاصة ويجب أن يتكون من:",
            codeCountry: "كود الدولة",
            code: "كود المنطقة",
            number: "الرقم",
          },
          text: {
            title: "1. الرسائل النصية",
            instructions:
              "فيما يلي قائمة المعلومات المطلوبة لإرسال الرسائل النصية:",
          },
          media: {
            title: "2. الرسائل الوسائطية",
            instructions:
              "فيما يلي قائمة المعلومات المطلوبة لإرسال الرسائل النصية:",
          },
        },
      },
      notifications: {
        noTickets: "لا توجد إشعارات.",
        messageHidden: "رسالة مخفية",
        newMessage: "رسالة جديدة من",
      },
      triggerFlowModal: {
        title: "تفعيل التدفق",
        description:
          "اختر تدفقاً لتنفيذه في هذه المحادثة. ستتغير حالة المحادثة إلى 'بوت' أثناء التنفيذ.",
        selectFlow: "اختر تدفقاً",
        selectedFlow: "التدفق المختار",
        flowId: "معرف التدفق",
        noFlows: "لا توجد تدفقات نشطة",
        cancel: "إلغاء",
        trigger: "تفعيل التدفق",
        triggering: "جاري التفعيل...",
        success: "تم تفعيل التدفق بنجاح!",
        error: "خطأ في تفعيل التدفق",
      },
      quickMessages: {
        title: "الردود السريعة",
        searchPlaceholder: "البحث...",
        noAttachment: "بدون مرفق",
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "هذا الإجراء لا يمكن التراجع عنه! هل تريد المتابعة؟",
        },
        selectMessage: "اختيار الرد السريع",
        hasMedia: "مع وسائط",
        global: "عام",
        noResultsFound: "لم يتم العثور على رد سريع لبحثك",
        noQuickMessages: "لا توجد ردود سريعة متاحة",
        buttons: {
          add: "إضافة",
          attach: "إرفاق ملف",
          cancel: "إلغاء",
          edit: "تعديل",
        },
        toasts: {
          success: "تم إضافة الاختصار بنجاح!",
          deleted: "تم حذف الاختصار بنجاح!",
        },
        dialog: {
          title: "الرسالة السريعة",
          shortcode: "الاختصار",
          message: "الرد",
          save: "حفظ",
          cancel: "إلغاء",
          geral: "السماح بالتعديل",
          add: "إضافة",
          general: "عام",
          visao: "السماح بالعرض",
        },
        table: {
          shortcode: "الاختصار",
          message: "الرسالة",
          actions: "الإجراءات",
          mediaName: "اسم الملف",
          status: "الحالة",
        },
      },
      contactLists: {
        title: "قوائم جهات الاتصال",
        table: {
          name: "الاسم",
          contacts: "جهات الاتصال",
          actions: "الإجراءات",
        },
        buttons: {
          add: "قائمة جديدة",
        },
        dialog: {
          name: "الاسم",
          company: "الشركة",
          okEdit: "تعديل",
          okAdd: "إضافة",
          add: "إضافة",
          edit: "تعديل",
          cancel: "إلغاء",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        toasts: {
          deleted: "تم حذف السجل",
        },
      },
      contactListItems: {
        title: "جهات الاتصال",
        searchPlaceholder: "البحث",
        buttons: {
          add: "جديد",
          lists: "القوائم",
          import: "استيراد",
        },
        dialog: {
          name: "الاسم",
          number: "الرقم",
          whatsapp: "الواتس اب",
          email: "البريد الإلكتروني",
          okEdit: "تعديل",
          okAdd: "إضافة",
          add: "إضافة",
          edit: "تعديل",
          cancel: "إلغاء",
        },
        table: {
          name: "الاسم",
          number: "الرقم",
          whatsapp: "الواتس اب",
          email: "البريد الإلكتروني",
          actions: "الإجراءات",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
          importMessage: "هل تريد استيراد جهات الاتصال من هذا الملف؟ ",
          importTitlte: "استيراد",
        },
        toasts: {
          deleted: "تم حذف السجل",
        },
      },

      kanban: {
        title: "الكانبان",
        searchPlaceholder: "البحث",
        subMenus: {
          list: "اللوحة",
          tags: "المسارات",
        },
      },

      campaigns: {
        title: "الحملات",
        searchPlaceholder: "البحث",
        subMenus: {
          list: "القائمة",
          listContacts: "قائمة جهات الاتصال",
          settings: "الإعدادات",
        },
        settings: {
          randomInterval: "فاصل زمني عشوائي للإرسال",
          noBreak: "بدون فاصل",
          intervalGapAfter: "فاصل أكبر بعد",
          undefined: "غير محدد",
          messages: "رسائل",
          laggerTriggerRange: "فاصل إرسال أكبر",
          addVar: "إضافة متغير",
          save: "حفظ",
          close: "إغلاق",
          add: "إضافة",
          shortcut: "اختصار",
          content: "المحتوى",
        },
        buttons: {
          add: "حملة جديدة",
          contactLists: "قوائم جهات الاتصال",
        },
        table: {
          name: "الاسم",
          whatsapp: "الاتصال",
          contactList: "قائمة جهات الاتصال",
          option: "لا شيء",
          disabled: "معطل",
          enabled: "مفعل",
          status: "الحالة",
          scheduledAt: "الجدولة",
          completedAt: "مكتملة",
          confirmation: "التأكيد",
          actions: "الإجراءات",
        },
        dialog: {
          new: "حملة جديدة",
          update: "تعديل الحملة",
          readonly: "عرض فقط",
          help: "استخدم متغيرات مثل {الاسم}، {الرقم}، {البريد} أو حدد متغيرات مخصصة.",
          form: {
            name: "الاسم",
            message1: "الرسالة 1",
            message2: "الرسالة 2",
            message3: "الرسالة 3",
            message4: "الرسالة 4",
            message5: "الرسالة 5",
            confirmationMessage1: "رسالة التأكيد 1",
            confirmationMessage2: "رسالة التأكيد 2",
            confirmationMessage3: "رسالة التأكيد 3",
            confirmationMessage4: "رسالة التأكيد 4",
            confirmationMessage5: "رسالة التأكيد 5",
            messagePlaceholder: "محتوى الرسالة",
            whatsapp: "الاتصال",
            status: "الحالة",
            scheduledAt: "الجدولة",
            confirmation: "التأكيد",
            contactList: "قائمة جهات الاتصال",
            tagList: "العلامات",
            statusTicket: "حالة المحادثة",
            openTicketStatus: "مفتوحة",
            pendingTicketStatus: "معلقة",
            closedTicketStatus: "مغلقة",
            enabledOpenTicket: "مفعل",
            disabledOpenTicket: "معطل",
            openTicket: "فتح محادثة",
          },
          buttons: {
            add: "إضافة",
            edit: "تحديث",
            okadd: "موافق",
            cancel: "إلغاء الإرسال",
            restart: "إعادة تشغيل الإرسال",
            close: "إغلاق",
            attach: "إرفاق ملف",
          },
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        toasts: {
          success: "تم تنفيذ العملية بنجاح",
          cancel: "تم إلغاء الحملة",
          restart: "تم إعادة تشغيل الحملة",
          deleted: "تم حذف السجل",
        },
      },
      campaignReport: {
        title: "تقرير",
        inactive: "غير نشطة",
        scheduled: "مجدولة",
        process: "قيد التنفيذ",
        cancelled: "ملغاة",
        finished: "منتهية",
        campaign: "الحملة",
        validContacts: "جهات اتصال صالحة",
        confirmationsRequested: "تأكيدات مطلوبة",
        confirmations: "تأكيدات",
        deliver: "مسلمة",
        connection: "الاتصال",
        contactLists: "قائمة جهات الاتصال",
        schedule: "الجدولة",
        conclusion: "الخلاصة",
        fetchError: "خطأ في جلب بيانات التقرير",
        backButton: "العودة",
      },
      announcements: {
        title: "الإعلانات",
        searchPlaceholder: "البحث",
        active: "نشط",
        inactive: "غير نشط",
        buttons: {
          add: "إعلان جديد",
          contactLists: "قوائم الإعلانات",
        },
        table: {
          priority: "الأولوية",
          title: "العنوان",
          text: "النص",
          mediaName: "الملف",
          status: "الحالة",
          actions: "الإجراءات",
        },
        dialog: {
          edit: "تعديل الإعلان",
          add: "إعلان جديد",
          update: "تعديل الإعلان",
          readonly: "عرض فقط",
          form: {
            priority: "الأولوية",
            title: "العنوان",
            text: "النص",
            mediaPath: "الملف",
            status: "الحالة",
            high: "عالية",
            medium: "متوسطة",
            low: "منخفضة",
            active: "نشط",
            inactive: "غير نشط",
          },
          buttons: {
            add: "إضافة",
            edit: "تحديث",
            okadd: "موافق",
            cancel: "إلغاء",
            close: "إغلاق",
            attach: "إرفاق ملف",
          },
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        toasts: {
          success: "تم تنفيذ العملية بنجاح",
          deleted: "تم حذف السجل",
        },
      },
      campaignsConfig: {
        title: "إعدادات الحملات",
        buttons: {
          filter: "تطبيق الفلتر",
          onlyRated: "المقيمة فقط",
        },
      },
      queues: {
        title: "الطوابير والبوت",
        table: {
          name: "الاسم",
          color: "اللون",
          greeting: "رسالة الترحيب",
          orderQueue: "ترتيب الطابور (البوت)",
          actions: "الإجراءات",
          ID: "المعرف",
        },
        buttons: {
          add: "إضافة طابور",
        },
        toasts: {
          success: "تم حفظ الطابور بنجاح",
          deleted: "تم حذف الطابور بنجاح",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage:
            "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء! محادثات هذا الطابور ستبقى موجودة، لكن لن يكون لها طابور مخصص.",
        },
      },
      queue: {
        queueData: "البيانات",
      },
      queueSelect: {
        inputLabel: "الطوابير",
        inputLabelRO: "طوابير للقراءة فقط",
        withoutQueue: "بدون طابور",
      },
      reports: {
        title: "تقارير المحادثات",
        startDate: "التاريخ الأولي",
        endDate: "التاريخ النهائي",
        table: {
          id: "المحادثة",
          user: "المستخدم",
          dateOpen: "تاريخ الفتح",
          dateClose: "تاريخ الإغلاق",
          NPS: "NPS",
          status: "الحالة",
          whatsapp: "الاتصال",
          queue: "الطابور",
          actions: "الإجراءات",
          lastMessage: "آخر رسالة",
          contact: "العميل",
          supportTime: "وقت المحادثة",
        },
        buttons: {
          filter: "تطبيق المرشح",
          onlyRated: "المقيمة فقط",
        },
        searchPlaceholder: "البحث...",
      },
      queueIntegration: {
        title: "التكاملات",
        table: {
          id: "المعرف",
          type: "النوع",
          name: "الاسم",
          projectName: "اسم المشروع",
          language: "اللغة",
          lastUpdate: "آخر تحديث",
          actions: "الإجراءات",
        },
        buttons: {
          add: "إضافة مشروع",
        },
        searchPlaceholder: "البحث...",
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage:
            "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء! وسيتم إزالته من الطوابير والاتصالات المرتبطة",
        },
      },
      users: {
        title: "المستخدمون",
        table: {
          status: "الحالة",
          name: "الاسم",
          email: "البريد الإلكتروني",
          profile: "الملف الشخصي",
          startWork: "بداية العمل",
          endWork: "نهاية العمل",
          actions: "الإجراءات",
          ID: "المعرف",
        },
        buttons: {
          add: "إضافة مستخدم",
        },
        toasts: {
          deleted: "تم حذف المستخدم بنجاح.",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage:
            "جميع بيانات المستخدم ستفقد. المحادثات المفتوحة لهذا المستخدم ستنقل للطابور.",
        },
      },
      compaies: {
        title: "الشركات",
        table: {
          ID: "المعرف",
          status: "نشط",
          name: "الاسم",
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          phone: "الهاتف",
          plan: "الخطة",
          active: "نشط",
          numberAttendants: "المشغلين",
          numberConections: "الاتصالات",
          value: "القيمة",
          namePlan: "اسم الخطة",
          numberQueues: "الطوابير",
          useCampaigns: "الحملات",
          useExternalApi: "Rest API",
          useFacebook: "فيسبوك",
          useInstagram: "إنستجرام",
          useWhatsapp: "واتس اب",
          useInternalChat: "المحادثة الداخلية",
          useSchedules: "الجدولة",
          createdAt: "تم الإنشاء في",
          dueDate: "الاستحقاق",
          lastLogin: "آخر دخول",
          folderSize: "حجم المجلد ",
          totalFiles: " إجمالي الملفات",
          lastUpdate: "آخر تحديث",
          actions: "الإجراءات",
          money: "ر.س",
          yes: "نعم",
          no: "لا",
          document: "السجل التجاري/الهوية",
          recurrence: "التكرار",
          monthly: "شهري",
          bimonthly: "شهرين",
          quarterly: "ربع سنوي",
          semester: "نصف سنوي",
          yearly: "سنوي",
          clear: "مسح",
          delete: "حذف",
          user: "المستخدم",
          save: "حفظ",
          generateInvoice: "إنشاء فاتورة",
        },
        buttons: {
          add: "إضافة شركة",
        },
        toasts: {
          deleted: "تم حذف الشركة بنجاح.",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage:
            "جميع بيانات الشركة ستفقد. المحادثات المفتوحة لهذا المستخدم ستنقل للطابور.",
        },
      },
      plans: {
        form: {
          name: "الاسم",
          users: "المستخدمون",
          connections: "الاتصالات",
          campaigns: "الحملات",
          schedules: "الجدولة",
          enabled: "مفعل",
          disabled: "معطل",
          clear: "إلغاء",
          delete: "حذف",
          save: "حفظ",
          yes: "نعم",
          no: "لا",
          money: "ر.س",
          public: "عام",
          trial: "تجريبي",
          trialDays: "أيام التجربة",
        },
      },
      helps: {
        title: "مركز المساعدة",
        settings: {
          codeVideo: "كود الفيديو",
          description: "الوصف",
          clear: "مسح",
          delete: "حذف",
          save: "حفظ",
        },
      },
      schedules: {
        title: "الجدولة",
        date: "التاريخ",
        time: "الوقت",
        event: "الحدث",
        allDay: "اليوم كله",
        week: "الأسبوع",
        work_week: "الجدولة",
        day: "اليوم",
        month: "الشهر",
        previous: "السابق",
        next: "التالي",
        yesterday: "أمس",
        tomorrow: "غداً",
        today: "اليوم",
        agenda: "الأجندة",
        noEventsInRange: "لا توجد جدولة في هذه الفترة.",
        confirmationModal: {
          deleteTitle: "هل أنت متأكد من حذف هذه الجدولة؟",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        table: {
          contact: "جهة الاتصال",
          body: "الرسالة",
          sendAt: "تاريخ الجدولة",
          sentAt: "تاريخ الإرسال",
          status: "الحالة",
          actions: "الإجراءات",
        },
        buttons: {
          add: "جدولة جديدة",
        },
        toasts: {
          deleted: "تم حذف الجدولة بنجاح.",
        },
      },
      tags: {
        title: "العلامات",
        addColumns: "+ إضافة أعمدة",
        search: "البحث",
        seeTicket: "عرض المحادثة",
        confirmationModal: {
          deleteTitle: "هل أنت متأكد من حذف هذه العلامة؟",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        table: {
          id: "المعرف",
          name: "الاسم",
          kanban: "الكانبان",
          color: "اللون",
          tickets: "سجلات العلامات",
          contacts: "جهات الاتصال",
          actions: "الإجراءات",
        },
        buttons: {
          add: "علامة جديدة",
        },
        toasts: {
          deleted: "تم حذف العلامة بنجاح.",
        },
      },

      tagsKanban: {
        title: "المسارات",
        laneDefault: "مفتوحة",
        backToKanban: "العودة للكانبان",

        confirmationModal: {
          deleteTitle: "هل أنت متأكد من حذف هذا المسار؟",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        table: {
          name: "الاسم",
          color: "اللون",
          tickets: "المحادثات",
          actions: "الإجراءات",
        },
        buttons: {
          add: "مسار جديد",
        },
        toasts: {
          deleted: "تم حذف المسار بنجاح.",
        },
      },

      files: {
        title: "قائمة الملفات",
        table: {
          name: "الاسم",
          contacts: "جهات الاتصال",
          actions: "الإجراءات",
        },
        toasts: {
          deleted: "تم حذف القائمة بنجاح!",
          deletedAll: "تم حذف جميع القوائم بنجاح!",
        },
        buttons: {
          add: "إضافة",
          deleteAll: "حذف الكل",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteAllTitle: "حذف الكل",
          deleteMessage: "هل أنت متأكد من حذف هذه القائمة؟",
          deleteAllMessage: "هل أنت متأكد من حذف جميع القوائم؟",
        },
      },
      settings: {
        success: "تم حفظ الإعدادات بنجاح.",
        title: "الإعدادات",
        tabs: {
          options: "الخيارات",
          plans: "الخطط",
          helps: "المساعدة",
          companies: "الشركات",
        },
        settings: {
          userCreation: {
            name: "إنشاء المستخدم",
            options: {
              enabled: "مفعل",
              disabled: "معطل",
            },
          },
          tabs: {
            options: "الخيارات",
            schedules: "المواعيد",
            plans: "الخطط",
            help: "المساعدة",
          },
          options: {
            disabled: "معطل",
            enabled: "مفعل",
            updating: "جاري التحديث...",
            creationCompanyUser: "إنشاء الشركة/المستخدم",
            evaluations: "التقييمات",
            officeScheduling: "جدولة المكتب",
            queueManagement: "الإدارة بالطابور",
            companyManagement: "الإدارة بالشركة",
            connectionManagement: "الإدارة بالاتصال",
            sendGreetingAccepted: "إرسال الترحيب عند قبول المحادثة",
            sendMsgTransfTicket: "إرسال رسالة نقل القسم/المشغل",
            checkMsgIsGroup: "تجاهل رسائل المجموعات",
            chatBotType: "نوع البوت",
            userRandom: "اختيار مشغل عشوائي",
            buttons: "الأزرار",
            acceptCallWhatsapp: "إعلام عدم قبول المكالمات في الواتس اب؟",
            sendSignMessage: "السماح للمشغل باختيار إرسال التوقيع",
            sendGreetingMessageOneQueues:
              "إرسال الترحيب عند وجود طابور واحد فقط",
            sendQueuePosition: "إرسال رسالة مع موقع الطابور",
            sendFarewellWaitingTicket: "إرسال رسالة الوداع في الانتظار",
            acceptAudioMessageContact: "قبول الصوتيات من جميع جهات الاتصال؟",
            enableLGPD: "تفعيل معاملة LGPD",
            requiredTag: "علامة إجبارية لإغلاق المحادثة",
            closeTicketOnTransfer: "إغلاق المحادثة عند النقل لطابور آخر",
            DirectTicketsToWallets: "نقل العميل تلقائياً للمحفظة",
            showNotificationPending: "إظهار إشعار للمحادثات المعلقة",
            transferredTicketStatus: "حالة المحادثة عند النقل مع المستخدم",
            copyContactPrefix: "بادئة لنسخ جهات الاتصال",
            copyContactPrefixPlaceholder: "مثال: COPIA_",
            open: "مفتوح",
            pending: "معلق",
          },
          customMessages: {
            sendQueuePositionMessage: "رسالة الموقع في الطابور",
            AcceptCallWhatsappMessage: "رسالة إعلام عدم قبول المكالمات",
            greetingAcceptedMessage: "رسالة الترحيب عند قبول المحادثة",
            transferMessage: "رسالة النقل - ${queue.name} = الطابور المقصود",
          },
          LGPD: {
            title: "LGPD",
            welcome: "رسالة الترحيب (LGPD)",
            linkLGPD: "رابط سياسة الخصوصية",
            obfuscateMessageDelete: "إخفاء الرسالة المحذوفة",
            alwaysConsent: "طلب الموافقة دائماً",
            obfuscatePhoneUser: "إخفاء رقم الهاتف للمستخدمين",
            enabled: "مفعل",
            disabled: "معطل",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "مخصص لـ:",
          dialogRatingTitle: "هل تريد ترك تقييم للخدمة للعميل؟",
          dialogClosingTitle: "إنهاء المحادثة مع العميل!",
          dialogRatingCancel: "حل مع رسالة الوداع",
          dialogRatingSuccess: "حل وإرسال التقييم",
          dialogRatingWithoutFarewellMsg: "حل بدون رسالة الوداع",
          ratingTitle: "اختر قائمة تقييم",
          notMessage: "لا توجد رسالة مختارة",
          amount: "قيمة الاستطلاع",
          buttons: {
            return: "إرجاع",
            resolve: "حل",
            reopen: "إعادة فتح",
            accept: "قبول",
            rating: "إرسال التقييم",
            enableIntegration: "تفعيل التكامل",
            disableIntegration: "تعطيل التكامل",
            logTicket: "سجلات المحادثة",
            requiredTag: "يجب تخصيص علامة قبل إغلاق المحادثة.",
            greetingAcceptedMessage: "يجب إعداد رسالة ترحيب عند قبول المحادثة.",
            newTicket: "إنشاء محادثة جديدة",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage: "اكتب رسالة أو اضغط / للردود السريعة",
        placeholderOpen: "اكتب رسالة أو اضغط / للردود السريعة",
        placeholderClosed: "أعد فتح أو اقبل هذه المحادثة لإرسال رسالة.",
        placeholderPending: "اكتب رسالتك الداخلية (المحادثة في الانتظار)...",
        signMessage: "توقيع",
        privateMessage: "رسالة خاصة",
      },
      contactDrawer: {
        header: "بيانات جهة الاتصال",
        buttons: {
          edit: "تعديل جهة الاتصال",
          block: "حظر",
          unblock: "إلغاء الحظر",
        },
        extraInfo: "معلومات أخرى",
      },
      messageVariablesPicker: {
        label: "المتغيرات المتاحة",
        vars: {
          contactFirstName: "الاسم الأول",
          contactName: "الاسم",
          user: "المشغل",
          greeting: "الترحيب",
          protocolNumber: "البروتوكول",
          date: "التاريخ",
          hour: "الساعة",
          ticket_id: "رقم المحادثة",
          queue: "القسم",
          connection: "الاتصال",
        },
      },
      ticketOptionsMenu: {
        schedule: "جدولة",
        delete: "حذف",
        transfer: "نقل",
        registerAppointment: "ملاحظات جهة الاتصال",
        resolveWithNoFarewell: "إنهاء بدون وداع",
        acceptAudioMessage: "قبول صوتيات جهة الاتصال؟",
        appointmentsModal: {
          title: "ملاحظات المحادثة",
          textarea: "الملاحظة",
          placeholder: "أدخل هنا المعلومة التي تريد تسجيلها",
        },
        confirmationModal: {
          title: "حذف محادثة جهة الاتصال",
          titleFrom: "من جهة الاتصال ",
          message: "تنبيه! جميع الرسائل المتعلقة بالمحادثة ستفقد.",
        },
        buttons: {
          delete: "حذف",
          cancel: "إلغاء",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "موافق",
          cancel: "إلغاء",
        },
      },
      messageInput: {
        tooltip: {
          signature: "تفعيل/تعطيل التوقيع",
          privateMessage: "تفعيل/تعطيل الرسالة الخاصة",
          meet: "إرسال رابط مؤتمر فيديو",
          triggerFlow: "تفعيل التدفق",
        },
        type: {
          imageVideo: "الصور والفيديوهات",
          cam: "الكاميرا",
          contact: "جهة الاتصال",
          meet: "مكالمة فيديو",
          template: "قالب ميتا",
        },
        pendingAlert: {
          title: "المحادثة في الانتظار:",
          description: "يُسمح فقط بالرسائل الداخلية في الوقت الحالي.",
        },
        flowAlert: {
          title: "التدفق قيد التنفيذ:",
          description: "حقل الرسالة معطل مؤقتاً.",
        },
        formatMenu: {
          bold: "عريض",
          italic: "مائل",
          strikethrough: "يتوسطه خط",
          code: "كود",
          numberedList: "قائمة مرقمة",
          bulletList: "قائمة نقطية",
          quote: "اقتباس",
          clearFormat: "إزالة التنسيق",
        },
        ghostMention: {
          tooltip: "إشارة شبح (تُنبّه الجميع دون إظهار @)",
          label: "إشارة شبح",
        },
        signature: {
          label: "التوقيع",
        },
        comments: {
          tooltip: "تفعيل/تعطيل التعليقات",
          label: "التعليقات",
        },
        quickAnswers: {
          hintNavigate: "{{count}} ردود • استخدم ↑↓ للتنقل",
          hintScroll: "{{count}} ردود • مرر لرؤية المزيد",
        },
        errors: {
          ticketIdNotFound: "خطأ: معرّف التذكرة غير موجود",
        },
        internalMessageLabel: "رسالة داخلية",
      },
      messageOptionsMenu: {
        delete: "حذف",
        reply: "رد",
        edit: "تعديل",
        forward: "إعادة توجيه",
        toForward: "إعادة توجيه",
        talkTo: "محادثة مع",
        confirmationModal: {
          title: "حذف الرسالة؟",
          message: "لا يمكن التراجع عن هذا الإجراء.",
        },
      },
      invoices: {
        table: {
          invoices: "الفواتير",
          details: "التفاصيل",
          users: "المستخدمون",
          connections: "الاتصالات",
          queue: "الطوابير",
          value: "القيمة",
          expirationDate: "تاريخ الاستحقاق",
          action: "الإجراء",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "يجب أن يكون هناك واتس اب افتراضي واحد على الأقل.",
        ERR_NO_DEF_WAPP_FOUND:
          "لم يتم العثور على واتس اب افتراضي. تحقق من صفحة الاتصالات.",
        ERR_WAPP_NOT_INITIALIZED:
          "جلسة الواتس اب هذه لم يتم تهيئتها. تحقق من صفحة الاتصالات.",
        ERR_WAPP_CHECK_CONTACT:
          "لا يمكن التحقق من جهة اتصال الواتس اب. تحقق من صفحة الاتصالات",
        ERR_WAPP_INVALID_CONTACT: "هذا ليس رقم واتس اب صالح.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "لا يمكن تحميل الوسائط من الواتس اب. تحقق من صفحة الاتصالات.",
        ERR_INVALID_CREDENTIALS: "خطأ في المصادقة. حاول مرة أخرى.",
        ERR_SENDING_WAPP_MSG:
          "خطأ في إرسال رسالة الواتس اب. تحقق من صفحة الاتصالات.",
        ERR_DELETE_WAPP_MSG: "لا يمكن حذف رسالة الواتس اب.",
        ERR_OTHER_OPEN_TICKET: "يوجد محادثة مفتوحة لجهة الاتصال هذه بالفعل.",
        ERR_SESSION_EXPIRED: "انتهت الجلسة. يرجى الدخول.",
        ERR_USER_CREATION_DISABLED: "تم تعطيل إنشاء المستخدم من قبل المدير.",
        ERR_NO_PERMISSION: "ليس لديك صلاحية للوصول لهذا المورد.",
        ERR_DUPLICATED_CONTACT: "يوجد جهة اتصال بهذا الرقم بالفعل.",
        ERR_NO_SETTING_FOUND: "لم يتم العثور على إعداد بهذا المعرف.",
        ERR_NO_CONTACT_FOUND: "لم يتم العثور على جهة اتصال بهذا المعرف.",
        ERR_NO_TICKET_FOUND: "لم يتم العثور على محادثة بهذا المعرف.",
        ERR_NO_USER_FOUND: "لم يتم العثور على مستخدم بهذا المعرف.",
        ERR_NO_WAPP_FOUND: "لم يتم العثور على واتس اب بهذا المعرف.",
        ERR_CREATING_MESSAGE: "خطأ في إنشاء الرسالة في قاعدة البيانات.",
        ERR_CREATING_TICKET: "خطأ في إنشاء المحادثة في قاعدة البيانات.",
        ERR_FETCH_WAPP_MSG:
          "خطأ في جلب الرسالة من الواتس اب، ربما تكون قديمة جداً.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "هذا اللون مستخدم بالفعل، اختر لوناً آخر.",
        ERR_WAPP_GREETING_REQUIRED:
          "رسالة الترحيب مطلوبة عند وجود أكثر من طابور واحد.",
        ERR_OUT_OF_HOURS: "خارج ساعات العمل!",
      },
      messagesAPIInstructions: {
        endpoint: "نقطة النهاية:",
        method: "الطريقة:",
        post: "POST",
        headers: "الرؤوس:",
        headerAuthorization:
          "Authorization Bearer (الرمز المسجل) و Content-Type (application/json)",
        body: "المحتوى:",
        fieldNumber: '"number": "966555999999"',
        fieldBody: '"body": "الرسالة"',
        fieldUserId: '"userId": معرف المستخدم أو ""',
        fieldQueueId: '"queueId": معرف الطابور أو ""',
        fieldSendSignature: '"sendSignature": توقيع الرسالة - true/false',
        fieldCloseTicket: '"closeTicket": إنهاء المحادثة - true/false',
        singMessage: "توقيع الرسالة - true/false",
        closeTicket: "إنهاء المحادثة - true/false",
        testSend: "اختبار الإرسال",
      },
      recurrenceSection: {
        title: "التكرار",
        description:
          "يمكنك اختيار إرسال الرسالة بشكل متكرر واختيار الفاصل الزمني. إذا كانت رسالة لإرسالها مرة واحدة، لا تغير شيئاً في هذا القسم.",
        labelInterval: "الفاصل الزمني",
        intervalFilterValue: "قيمة الفاصل الزمني",
        sendAsManyTimes: " إرسال كم مرة",
        shipNormallyOnNonbusinessDays: " إرسال عادي في الأيام غير العمل",
        sendOneBusinessDayBefore: "إرسال يوم عمل قبل",
        sendOneBusinessDayLater: "إرسال يوم عمل بعد",
        options: {
          days: "أيام",
          weeks: "أسابيع",
          months: "أشهر",
          minutes: "دقائق",
        },
      },
      servicePanel: {
        allowRealTime: "لوحة المحادثات",
      },
      financial: {
        invoices: "الفواتير",
        details: "التفاصيل",
        users: "المستخدمون",
        connections: "الاتصالات",
        queues: "الطوابير",
        value: "القيمة",
        expirationDate: "تاريخ الاستحقاق",
        status: "الحالة",
        action: "الإجراء",
      },
      statusFilter: {
        statusFilter: "تصفية حسب الحالة",
      },
      momentsUser: {
        services: "المحادثات:",
        pending: "معلقة",
        noqueue: "بدون طابور",
      },
      campaignsPhrase: {
        campaignsFlow: "تدفق الحملات",
        campaigns: "الحملات",
        name: "الاسم",
        status: "الحالة",
        newCampaignWithFlowByPhrase: "حملة جديدة مع تدفق بالعبارة",
        editCampaignWithFlowByPhrase: "تعديل حملة مع تدفق بالعبارة",
        phraseTriggerName: "اسم التفعيل بالعبارة",
        chooseAStream: "اختر تدفقاً",
        whichPhraseTriggersTheFlow: " أي عبارة تفعل التدفق؟",
        selectAConnection: " اختر اتصالاً",
        cancel: "إلغاء",
        createCampaign: "إنشاء حملة ",
        saveCampaign: "حفظ الحملة",
        connections: "الاتصالات",
        newCampaign: "حملة جديدة",
        nameNotDefined: "الاسم غير محدد",
        phrasesConfigured: "{{count}} عبارة مُعدّة",
        active: "نشط",
        inactive: "غير نشط",
        editCampaignTooltip: "تعديل الحملة",
        deleteCampaignTooltip: "حذف الحملة",
        noCampaignsFound: "لم يتم العثور على حملات",
        noCampaignsHelper: "انقر على \"حملة جديدة\" لإنشاء أول حملة تدفق لك",
        noConnection: "لا يوجد اتصال",
        moreConnections: "{{count}} اتصال إضافي",
        toast: {
          deleted: "تم حذف الحملة بنجاح",
          errorLoadingFlows: "خطأ في تحميل التدفقات",
          errorLoadingConnections: "خطأ في تحميل الاتصالات",
          errorLoadingCampaign: "خطأ في تحميل بيانات الحملة",
          flowNotFound: "التدفق المحدد غير موجود",
          saveError: "خطأ في حفظ الحملة",
          fillRequiredFields: "يرجى ملء جميع الحقول المطلوبة",
          updated: "تم تحديث الحملة بنجاح!",
          created: "تم إنشاء الحملة بنجاح!",
        },
        campaignNameLabel: "اسم الحملة",
        selectFlowLabel: "اختر تدفقاً",
        multiple: "(متعدد)",
        whatsappConnectionsLabel: "اتصالات واتساب",
        connectionsSelectedTitle: "{{count}} اتصال محدد:",
        connectionsSelectedDescription: "سيتم تنفيذ الحملة عندما يستقبل أي من هذه الاتصالات رسائل تطابق العبارات المُعدّة.",
        filterByTag: "تصفية حسب وسم جهة الاتصال",
        optional: "(اختياري)",
        filterByTagDescription: "إذا تم تحديدها، سيتم تفعيل التدفق فقط لجهات الاتصال التي تملك واحدة على الأقل من هذه الوسوم في المحادثة.",
        tagsOptionalLabel: "الوسوم (اختياري)",
        tagFilterActive: "🏷️ التصفية مفعّلة: سيتم تفعيل التدفق فقط لجهات الاتصال التي تملك واحدة على الأقل من الوسوم الـ {{count}} المحددة.",
        keywordsTitle: "الكلمات المفتاحية التي تفعّل التدفق",
        orLogicInfo: "🔀 منطق أو: سيتم تفعيل التدفق إذا أرسل جهة الاتصال أياً من الكلمات/العبارات أدناه.",
        exactPartialInfo: "دقيقة: رسالة مطابقة تماماً.  |  جزئية: كلمة موجودة في أي جزء من الرسالة.",
        or: "أو",
        phraseLabel: "كلمة/عبارة {{index}}",
        phrasePlaceholder: "مثال: مرحباً، أريد عرض سعر...",
        type: "النوع",
        exact: "دقيقة",
        partial: "جزئية",
        addPhraseButton: "+ إضافة كلمة/عبارة أخرى (أو)",
        saving: "جارٍ الحفظ...",
        validation: {
          nameRequired: "الاسم مطلوب",
          flowRequired: "التدفق مطلوب",
          connectionRequired: "يجب تحديد اتصال واحد على الأقل",
          fieldRequired: "حقل مطلوب",
        },
      },
      whatsappModalRel: {
        form: {
          isOficial: "تقرير المحادثة",
          ticketId: "معرف المحادثة",
          client: "العميل",
          number: "الرقم",
          agent: "المشغل",
          date: "التاريخ",
          lastMessage: "آخر رسالة",
          fullReport: "التقرير الكامل مرفق أعلاه",
          resolveAndTriggerIntegration: "حل وتفعيل التكامل",
          elementNotFoundForExport: "العنصر غير موجود للتصدير.",
          reportFilename: "تقرير_المحادثة",
        },
      },
      chatList: {
        noMessages: "لا توجد رسائل",
        admin: "المدير",
        member: "عضو",
        searchChat: "البحث في المحادثة...",
        createNewChat: "إنشاء محادثة جديدة",
        searchUser: "البحث عن مستخدم...",
        noUserFound: "لم يتم العثور على مستخدم",
        noUserAvailable: "لا يوجد مستخدم متاح",
        cancel: "إلغاء",
        details: "التفاصيل",
        deleteChat: "حذف المحادثة",
        deleteChatConfirm: "لا يمكن التراجع عن هذا الإجراء، تأكيد؟",
        detailsTitle: "التفاصيل",
        edit: "تعديل",
        delete: "حذف",
        now: "الآن",
        minutesAgo: "{{count}} د مضت",
        hoursAgo: "{{count}} س مضت",
      },
      chatMessages: {
        deleted: "تم حذف هذه الرسالة",
        deletedAdmin: "رسالة محذوفة - مرئية للمديرين فقط",
        reply: "رد",
        edit: "تعديل",
        delete: "حذف",
        forward: "إعادة توجيه",
        editMessage: "تعديل الرسالة",
        save: "حفظ",
        cancel: "إلغاء",
        deleteMessage: "حذف الرسالة",
        deleteMessageConfirm: "هل أنت متأكد من حذف هذه الرسالة؟",
        forwardMessage: "إعادة توجيه الرسالة",
        selectChat: "اختر المحادثة",
        doubleClickToReply: "انقر مرتين للرد",
        edited: "(معدلة)",
        forwarded: "(معاد توجيهها)",
        typeMessage: "اكتب رسالة...",
        send: "إرسال",
        noMessages: "لا توجد رسائل",
        loading: "جاري التحميل...",
        replyingTo: "رد على",
        clickToGoToOriginal: "انقر للذهاب للرسالة الأصلية",
      },
      chatPopover: {
        reply: "رد",
        edit: "تعديل",
        delete: "حذف",
        forward: "إعادة توجيه",
        cancel: "إلغاء",
        confirmDelete: "تأكيد الحذف",
        confirm: "تأكيد",
        deleteMessage: "هل أنت متأكد من حذف هذه الرسالة؟",
        editMessage: "تعديل الرسالة",
        save: "حفظ",
        forwardMessage: "إعادة توجيه الرسالة",
        selectChat: "اختر المحادثة",
        forward: "إعادة توجيه",
        noChats: "لا توجد محادثة متاحة",
      },
      chatIndex: {
        chats: "المحادثات",
        groups: "المجموعات",
        new: "جديد",
        messages: "الرسائل",
        search: "البحث...",
        noChats: "لا توجد محادثة",
        noGroups: "لا توجد مجموعة",
        noMessages: "لا توجد رسائل",
        loading: "جاري التحميل...",
        error: "خطأ في تحميل البيانات",
        addGroupPhoto: "إضافة صورة المجموعة",
        changeGroupPhoto: "تغيير صورة المجموعة",
        groupName: "اسم المجموعة",
        groupDescription: "وصف المجموعة",
        save: "حفظ",
        cancel: "إلغاء",
        createGroup: "إنشاء مجموعة",
        editGroup: "تعديل المجموعة",
        deleteGroup: "حذف المجموعة",
        deleteGroupConfirm: "هل أنت متأكد من حذف هذه المجموعة؟",
        edit: "تعديل",
        delete: "حذف",
        details: "التفاصيل",
        groupDetails: "تفاصيل المجموعة",
        title: "العنوان",
        description: "الوصف",
        modal: {
          title: "إنشاء مجموعة",
          name: "اسم المجموعة",
          description: "وصف المجموعة",
          create: "إنشاء",
          cancel: "إلغاء",
          save: "حفظ",
          edit: "تعديل",
        },
        modal: {
          title: "إنشاء مجموعة",
          editTitle: "تعديل المجموعة",
          save: "حفظ",
          cancel: "إلغاء",
        },
      },
      whitelabel: {
        primaryColorLight: "اللون الأساسي (المظهر الفاتح)",
        primaryColorDark: "اللون الأساسي (المظهر الداكن)",
        appName: "اسم التطبيق",
        logoLight: "الشعار (المظهر الفاتح)",
        logoDark: "الشعار (المظهر الداكن)",
        favicon: "الأيقونة المفضلة",
        backgroundLight: "صورة الخلفية (المظهر الفاتح)",
        backgroundDark: "صورة الخلفية (المظهر الداكن)",
        preview: "معاينة",
        delete: "حذف",
        upload: "رفع",
        availableLanguages: "اللغات المتاحة",
        atLeastOneLanguage: "يجب تفعيل لغة واحدة على الأقل",
        sections: {
          general: "الإعدادات العامة",
          generalDescription: "تكوين الاسم والمعلومات الأساسية للتطبيق",
          colors: "الألوان والمظاهر",
          colorsDescription: "تخصيص الألوان الأساسية للمظاهر الفاتحة والداكنة",
          logos: "الشعارات والصور",
          logosDescription: "رفع شعارات وصور خلفية التطبيق",
          languages: "اللغات المتاحة",
          languagesDescription: "اختر اللغات المتاحة في النظام",
        },
      },
    },
  },
};

export { messages };
